import React, {Component} from 'react';
import {observable, action} from 'mobx';
import { observer, inject } from 'mobx-react';
import Papa from 'papaparse';
import XLSX from 'xlsx/dist/xlsx.full.min.js';

import _ from "underscore";
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import HelpButton from "../../../components/common/HelpButton";
import guideManager from "../../../guides/guideManager";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
  FormTextarea,
  FormSelect,
  Modal,
  FormInput,
  Button
} from "shards-react";
import {Link} from 'react-router-dom';
import moment from "moment";
import {reactLocalStorage as Storage} from "reactjs-localstorage";

@inject(({ common }) => ({ getUploadUrl: common.getUploadUrl, base64UploadImages: common.base64UploadImages, cafe24UploadFiles: common.cafe24UploadFiles, uploadImg: common.uploadImg, removeMedia: common.removeMedia, getDoc: common.getDoc, getReviewMappingTemplates: common.getReviewMappingTemplates, saveReviewMappingTemplate: common.saveReviewMappingTemplate, deleteReviewMappingTemplate: common.deleteReviewMappingTemplate }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ product }) => ({ getProductList: product.getProductList, setProductSync: product.setProductSync, updateProductReplay: product.updateProductReplay }))
@inject(({ review }) => ({ updateReview:review.updateReview, uploadReviewExImgs:review.uploadReviewExImgs, updateMassReview:review.updateMassReview, getAnalysisList:review.getAnalysisList, genAIReviewAnalysis:review.genAIReviewAnalysis }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))

@observer
class ReviewMassWrite extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = false;
  @observable urlParams = new URLSearchParams(window.location.search);

  //list
  @observable filePlatform = "my"; //"my";
  @observable listParams = {
    page:1, limit:600,
  }
  @observable searchParams = {
    keyword: '',
    overReviewCount: '',
  };
  @observable list = [];
  @observable errData = [];
  // goodList — platformProductId → product 매핑(룩업 테이블). mobx observable array 였을 때 string key 할당이 array index out of bounds 에러를 유발해 객체로 변경
  @observable goodList = {};
  @observable exImgList = [];
  @observable uploadImgStatus = {};

  //modals
  @observable modals = {
    data: null,
    isWriteForm: false,
    widgetData: {},
    isMakeWidgetModal: false
  };

  @observable widgetUrl;
  @observable categories = [];
  @observable newReview = {};
  @observable isShowCollapse = false;
  @observable isUploading = false;
  @observable isUseImgCopy = true;
  @observable editingReview = {};
  @observable dragUploadIndex = null;

  // workflow / UX state
  @observable currentStep = 1;
  @observable maxReachedStep = 1;
  @observable selectedFile = null;
  @observable isExcelDragOver = false;
  @observable noticeAccordionOpen = false;
  @observable selectedRows = {};
  @observable registerResult = null;
  @observable isSubmitting = false;
  @observable showWarning = true;
  @observable warningAgreed = false;
  @observable fieldDetailExpanded = false;

  // 사용자 정의 ���식 매핑
  @observable savedMappings = [];
  @observable currentMapping = null;
  @observable isMappingModalOpen = false;
  @observable parsedRows = [];
  @observable parsedHeaders = [];
  @observable openDropdownColumn = null;
  @observable dropdownSearch = '';
  @observable dropdownAlign = 'center';
  @observable autoMatchedFields = {};
  @observable columnTypes = {};
  @observable dragOverColumn = null;
  @observable showProblemsOnly = false;

  // 상품 검색 모달
  @observable productSearchModal = {
    isOpen: false,
    targetIndex: -1,
    oldProductId: '',
    query: '',
    results: [],
    isSearching: false,
    applyToAll: true,
    matchCount: 1,
  };

  @observable mappingForm = {
    name: '',
    ratingScale: '5',
    saveAfterApply: true,
    fields: {
      contents: '',
      goodsPt: '',
      platformProductId: '',
      writerAt: '',
      writerId: '',
      writerName: '',
      subject: '',
      deliveryPt: '',
      images_1: '',
      images_2: '',
      images_3: '',
      images_4: '',
      images_5: '',
      movies_1: '',
      movies_2: '',
    },
  };

  constructor(props) {
    super(props);
    this.init()
  }

  handleDropAreaClick = (index) => {
    const input = document.getElementById(`imageUpload-${index}`);
    if (input) {
      input.click();
    }
  };

  // === workflow / UX helpers ===
  @action
  setStep = (step) => {
    this.currentStep = step;
    if (step > this.maxReachedStep) this.maxReachedStep = step;
    // 부드럽게 해당 섹션으로 스크롤
    setTimeout(() => {
      const el = document.getElementById(`rmw-step-${step}`);
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);
  };

  @action
  advanceStep = (step) => {
    if (step > this.maxReachedStep) this.maxReachedStep = step;
    if (step > this.currentStep) this.currentStep = step;
  };

  @action
  toggleNoticeAccordion = () => {
    this.noticeAccordionOpen = !this.noticeAccordionOpen;
  };

  @action
  setFilePlatform = (value) => {
    this.filePlatform = value;
  };

  // 유의사항 배너 — sessionStorage 기반 (reviewWrite 동일 패턴)
  WARNING_STORAGE_KEY = 'reviewMassWrite_warningAgreed';

  @action
  checkWarningAgreement = () => {
    try {
      if (sessionStorage.getItem(this.WARNING_STORAGE_KEY) === 'true') {
        this.showWarning = false;
        this.warningAgreed = true;
      }
    } catch (e) {}
  };

  @action
  toggleWarningAgree = () => {
    this.warningAgreed = !this.warningAgreed;
  };

  @action
  dismissWarning = () => {
    if (!this.warningAgreed) return;
    this.showWarning = false;
    try {
      sessionStorage.setItem(this.WARNING_STORAGE_KEY, 'true');
    } catch (e) {}
  };

  // === excel/csv 파일 드래그앤드롭 ===
  @action
  handleExcelDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.isExcelDragOver = true;
  };

  @action
  handleExcelDragOverEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    this.isExcelDragOver = true;
  };

  @action
  handleExcelDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.isExcelDragOver = false;
  };

  @action
  handleExcelDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.isExcelDragOver = false;
    const files = event.dataTransfer && event.dataTransfer.files ? Array.from(event.dataTransfer.files) : [];
    if (files.length === 0) return;
    const file = files[0];
    const ext = (file.name || '').split('.').pop().toLowerCase();
    if (['csv', 'xlsx', 'xls'].indexOf(ext) === -1) {
      toast.error('CSV 또는 엑셀(xlsx, xls) 파일만 업로드할 수 있습니다.');
      return;
    }
    this.selectedFile = { name: file.name, size: file.size };
    this.handleFileUpload({ target: { files: [file] } });
  };

  @action
  handleExcelFileChange = (event) => {
    const file = event.target && event.target.files ? event.target.files[0] : null;
    if (file) {
      this.selectedFile = { name: file.name, size: file.size };
    }
    this.handleFileUpload(event);
  };

  triggerExcelFileInput = () => {
    const input = document.getElementById('rmw-excel-input');
    if (input) input.click();
  };

  @action
  removeExcelFile = () => {
    this.selectedFile = null;
    this.list = [];
    this.errData = [];
    this.exImgList = [];
    this.selectedRows = {};
    this.parsedRows = [];
    this.parsedHeaders = [];
    this.currentMapping = null;
    this.currentStep = 1;
    const input = document.getElementById('rmw-excel-input');
    if (input) input.value = '';
  };

  formatFileSize = (size) => {
    if (!size && size !== 0) return '';
    if (size < 1024) return size + ' B';
    if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
    return (size / 1024 / 1024).toFixed(1) + ' MB';
  };

  // === 일괄 선택 ===
  @action
  toggleSelectRow = (idx) => {
    if (this.selectedRows[idx]) {
      delete this.selectedRows[idx];
    } else {
      this.selectedRows[idx] = true;
    }
    // mobx observable 갱신을 위해 새 객체 할당
    this.selectedRows = { ...this.selectedRows };
  };

  @action
  toggleSelectAll = () => {
    if (Object.keys(this.selectedRows).length === this.list.length && this.list.length > 0) {
      this.selectedRows = {};
    } else {
      const next = {};
      this.list.forEach((_, i) => { next[i] = true; });
      this.selectedRows = next;
    }
  };

  @action
  clearSelection = () => {
    this.selectedRows = {};
  };

  @action
  removeSelectedRows = () => {
    const indexes = Object.keys(this.selectedRows).map(Number);
    if (indexes.length === 0) return;
    if (!window.confirm(`선택한 ${indexes.length}건의 리뷰를 삭제하시겠습니까?`)) return;
    indexes.sort((a, b) => b - a).forEach(i => this.list.splice(i, 1));
    this.selectedRows = {};
    toast.success(`${indexes.length}건이 삭제되었습니다.`);
  };

  // 등록 가능한 유효 리뷰 수 (필수항목 충족 + 문법 위험 없음)
  getValidReviewCount = () => {
    if (!this.list || this.list.length === 0) return 0;
    return this.list.filter(item => !this.isInvalidReview(item) && !this.isSyntaxRiskReview(item)).length;
  };

  // 행 상태 분류: 'error' | 'warning' | 'valid'
  getRowStatus = (item) => {
    if (this.isInvalidReview(item)) return 'error';
    if (this.isSyntaxRiskReview(item)) return 'warning';
    return 'valid';
  };

  // 문제(오류 또는 경고) 리뷰 전체 건수
  getProblemReviewCount = () => {
    if (!this.list || this.list.length === 0) return 0;
    return this.list.filter(item => this.isInvalidReview(item) || this.isSyntaxRiskReview(item)).length;
  };

  // 문제 리뷰 일괄 삭제
  @action
  removeProblemReviews = () => {
    const problemCount = this.getProblemReviewCount();
    if (problemCount === 0) return;
    if (!window.confirm(`문제가 있는 ${problemCount}건의 리뷰를 모두 삭제하시겠습니까?\n(필수 항목 누락 및 문법 오류 위험 리뷰)`)) return;
    this.list = this.list.filter(item => !this.isInvalidReview(item) && !this.isSyntaxRiskReview(item));
    this.selectedRows = {};
    toast.success(`${problemCount}건의 문제 리뷰가 삭제되었습니다.`);
  };

  // 문제 리뷰만 보기 필터 토글
  @action
  toggleShowProblemsOnly = () => {
    this.showProblemsOnly = !this.showProblemsOnly;
  };

  // 첫 번째 문제 리뷰로 스크롤
  scrollToFirstProblem = () => {
    if (!this.list) return;
    for (let i = 0; i < this.list.length; i++) {
      if (this.isInvalidReview(this.list[i]) || this.isSyntaxRiskReview(this.list[i])) {
        // showProblemsOnly 가 꺼져있다면 테이블 위치 기준으로 스크롤
        const row = document.querySelector(`.rmw-data-row[data-row-index="${i}"]`);
        if (row && row.scrollIntoView) {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          row.classList.add('is-flash');
          setTimeout(() => row.classList.remove('is-flash'), 1400);
        }
        return;
      }
    }
  };

  @action
  resetForm = () => {
    this.list = [];
    this.errData = [];
    this.exImgList = [];
    this.selectedFile = null;
    this.registerResult = null;
    this.selectedRows = {};
    this.parsedRows = [];
    this.parsedHeaders = [];
    this.currentMapping = null;
    this.currentStep = 1;
    this.maxReachedStep = 1;
    const input = document.getElementById('rmw-excel-input');
    if (input) input.value = '';
    setTimeout(() => {
      const el = document.getElementById('rmw-step-1');
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  // === 사용자 정의 매핑 (DB 저장) ===
  @action
  loadSavedMappings = async () => {
    const _this = this;
    try {
      const res = await this.props.getReviewMappingTemplates({
        store_id: this.teamUser.selStore_id
      });
      _this.savedMappings = (res && res.data) ? res.data : [];
    } catch (e) {
      console.error('매핑 양식 불러오기 실패:', e);
      _this.savedMappings = [];
    }
  };

  saveMappingToServer = async (mappingDoc) => {
    const _this = this;
    try {
      const params = {
        store_id: this.teamUser.selStore_id,
        name: mappingDoc.name,
        columnSignature: mappingDoc.columnSignature || '',
        ratingScale: mappingDoc.ratingScale || '5',
        mapping: mappingDoc.mapping || {},
      };
      if (mappingDoc._id) params.id = mappingDoc._id;
      const res = await this.props.saveReviewMappingTemplate(params);
      if (res && res.data) {
        await _this.loadSavedMappings();
        return res.data;
      }
    } catch (e) {
      console.error('매핑 양식 저장 실패:', e);
      toast.error('양식 저장 중 오류가 발생했습니다.');
    }
    return null;
  };

  @action
  deleteSavedMapping = async (id) => {
    if (!window.confirm('이 양식을 삭제하시겠습니까?')) return;
    try {
      await this.props.deleteReviewMappingTemplate({
        store_id: this.teamUser.selStore_id,
        id: id,
      });
      this.savedMappings = this.savedMappings.filter(m => (m._id || m.id) !== id);
      toast.success('양식이 삭제되었습니다.');
    } catch (e) {
      console.error('매핑 양식 삭제 실패:', e);
      toast.error('양식 삭제 중 오류가 발생했습니다.');
    }
  };

  computeColumnSignature = (headers) => {
    return (headers || [])
      .filter(Boolean)
      .map(h => String(h).trim().toLowerCase())
      .sort()
      .join('|');
  };

  findMatchingSavedMapping = (headers) => {
    const sig = this.computeColumnSignature(headers);
    return this.savedMappings.find(m => m.columnSignature === sig);
  };

  // 컬럼 데이터 타입 감지
  detectColumnTypes = (rows, headers) => {
    const types = {};
    headers.forEach(h => {
      const samples = rows.slice(0, 30)
        .map(r => r && r[h])
        .filter(v => v !== '' && v !== null && v !== undefined);

      if (samples.length === 0) { types[h] = 'empty'; return; }

      const isNum = samples.every(v => !isNaN(parseFloat(v)) && isFinite(v));
      const isUrl = samples.every(v => typeof v === 'string' && /^https?:\/\//i.test(v));
      const isImgUrl = isUrl && samples.some(v => /\.(jpe?g|png|gif|webp|bmp)(\?|$)/i.test(v));
      const isMovUrl = isUrl && samples.some(v => /\.(mp4|webm|mov|avi)(\?|$)/i.test(v));
      const isDate = !isNum && samples.every(v => {
        if (typeof v === 'number' && v > 30000 && v < 100000) return true;
        if (typeof v === 'string' && /\d{4}[-./]\d{1,2}[-./]\d{1,2}/.test(v)) return true;
        return false;
      });
      const avgLen = samples.reduce((s, v) => s + String(v).length, 0) / samples.length;

      if (isImgUrl) types[h] = 'imgurl';
      else if (isMovUrl) types[h] = 'movurl';
      else if (isUrl) types[h] = 'url';
      else if (isDate) types[h] = 'date';
      else if (isNum) {
        const max = Math.max(...samples.map(v => parseFloat(v)));
        const min = Math.min(...samples.map(v => parseFloat(v)));
        if (min >= 0 && max <= 5) types[h] = 'rating5';
        else if (min >= 0 && max <= 100 && [20, 40, 60, 80, 100].some(x => samples.includes(x))) types[h] = 'rating100';
        else types[h] = 'number';
      }
      else if (avgLen > 50) types[h] = 'longtext';
      else types[h] = 'text';
    });
    return types;
  };

  // 컬럼 데이터 + 컬럼명 동시 분석으로 필드 추론 (자동 매칭)
  guessFieldMapping = (headers, rows) => {
    const FIELD_KEYWORDS = {
      contents: ['contents', 'content', 'review', '내용', '리뷰', '본문', 'text', 'body', 'comment', '리뷰내용'],
      goodsPt: ['goodspt', 'rating', 'star', '별점', '평점', '점수', 'score', '구매자평점'],
      platformProductId: ['productid', 'product_id', 'platformproductid', '상품번호', '상품id', '상품코드', 'item_no', 'sku'],
      writerAt: ['writerat', 'date', 'created', 'created_at', '작성일', '등록일', 'write_date', 'reg_date', '리뷰등록일'],
      writerId: ['writerid', 'userid', 'user_id', '아이디', 'id', 'memberid', 'member_id', '회원id'],
      writerName: ['writername', 'author', 'writer', '이름', '작성자', 'username', '등록자', '닉네임'],
      subject: ['subject', 'title', '제목', '상품명'],
      deliveryPt: ['deliverypt', 'delivery', '배송별점', '배송점수', '배송평점'],
      images_1: ['image', 'images', 'img', 'photo', '이미지', '사진', 'image1', 'image_1', 'images_1', '포토'],
      movies_1: ['movie', 'video', '영상', '비디오', 'video1', 'movie_1'],
    };
    const normalize = (s) => String(s || '').toLowerCase().replace(/[\s_\-/]/g, '');
    const types = rows ? this.detectColumnTypes(rows, headers) : {};
    const result = {};
    const used = new Set();

    // 1차: 컬럼명 키워드 매칭
    Object.keys(FIELD_KEYWORDS).forEach(field => {
      const kws = FIELD_KEYWORDS[field].map(normalize);
      const match = headers.find(h => {
        if (!h || used.has(h)) return false;
        const n = normalize(h);
        return kws.some(kw => n === kw || n.includes(kw));
      });
      if (match) {
        result[field] = match;
        used.add(match);
      }
    });

    // 2차: 데이터 타입 보강 (이름 매칭이 안 된 필드만)
    if (rows) {
      const need = (f) => !result[f];
      headers.forEach(h => {
        if (used.has(h)) return;
        const t = types[h];
        if (t === 'date' && need('writerAt')) { result.writerAt = h; used.add(h); return; }
        if (t === 'longtext' && need('contents')) { result.contents = h; used.add(h); return; }
        if ((t === 'rating5' || t === 'rating100') && need('goodsPt')) { result.goodsPt = h; used.add(h); return; }
        if (t === 'imgurl' && need('images_1')) { result.images_1 = h; used.add(h); return; }
        if (t === 'movurl' && need('movies_1')) { result.movies_1 = h; used.add(h); return; }
      });
    }

    return result;
  };

  parseExcelDateMaybe = (val) => {
    if (typeof val !== 'number') return val;
    try {
      const d = XLSX.SSF.parse_date_code(val);
      if (d) return `${d.y}-${String(d.m).padStart(2, '0')}-${String(d.d).padStart(2, '0')}`;
    } catch (e) {}
    return val;
  };

  @action
  parseCustomFile = (file) => {
    const _this = this;
    const ext = file.name.split('.').pop().toLowerCase();

    const handleParsed = (rows) => {
      if (!rows || rows.length === 0) {
        toast.error('파일에서 데이터를 읽을 수 없습니다.');
        _this.isLoading = false;
        return;
      }
      if (rows.length > _this.reviewSize) {
        alert(`${_this.reviewSize}개 이상의 리뷰를 한번에 등록할 수 없습니다.\n파일을 나눠서 등록 해주세요.`);
        _this.isLoading = false;
        return;
      }
      const headerSet = new Set();
      rows.forEach(r => Object.keys(r || {}).forEach(k => headerSet.add(k)));
      const headers = Array.from(headerSet).filter(Boolean);

      _this.parsedRows = rows;
      _this.parsedHeaders = headers;

      const matched = _this.findMatchingSavedMapping(headers);
      if (matched) {
        toast.success(`저장된 양식 "${matched.name}"이(가) 자동 적용되었습니다.`);
        _this.applyMapping(matched);
      } else {
        _this.isLoading = false;
        _this.openMappingModal(headers);
      }
    };

    this.isLoading = true;
    if (ext === 'csv') {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => handleParsed(result.data || []),
        error: (err) => {
          toast.error('CSV 파싱 오류: ' + err.message);
          _this.isLoading = false;
        },
      });
    } else if (ext === 'xlsx' || ext === 'xls') {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const wb = XLSX.read(data, { type: 'array' });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(ws, { defval: '' });
          handleParsed(rows);
        } catch (err) {
          toast.error('엑셀 파싱 오류: ' + err.message);
          _this.isLoading = false;
        }
      };
      reader.readAsArrayBuffer(file);
    } else {
      toast.error('지원하지 않는 파일 형식입니다.');
      _this.isLoading = false;
    }
  };

  @action
  openMappingModal = (headers) => {
    const hdrs = headers || this.parsedHeaders;
    const guesses = this.guessFieldMapping(hdrs, this.parsedRows);
    this.columnTypes = this.detectColumnTypes(this.parsedRows, hdrs);
    // 자동 매칭된 필드 표시 (뱃지용)
    const autoMatched = {};
    Object.keys(guesses).forEach(f => { if (guesses[f]) autoMatched[f] = true; });
    this.autoMatchedFields = autoMatched;
    // 평점 단위 자동 추정
    let ratingScale = '5';
    if (guesses.goodsPt && this.columnTypes[guesses.goodsPt] === 'rating100') ratingScale = '100';
    this.mappingForm = {
      name: '',
      ratingScale: ratingScale,
      saveAfterApply: true,
      fields: {
        contents: guesses.contents || '',
        goodsPt: guesses.goodsPt || '',
        platformProductId: guesses.platformProductId || '',
        writerAt: guesses.writerAt || '',
        writerId: guesses.writerId || '',
        writerName: guesses.writerName || '',
        subject: guesses.subject || '',
        deliveryPt: guesses.deliveryPt || '',
        images_1: guesses.images_1 || '',
        images_2: '',
        images_3: '',
        images_4: '',
        images_5: '',
        movies_1: guesses.movies_1 || '',
        movies_2: '',
      },
    };
    this.openDropdownColumn = null;
    this.dropdownSearch = '';
    this.isMappingModalOpen = true;
  };

  @action
  closeMappingModal = () => {
    this.isMappingModalOpen = false;
  };

  @action
  updateMappingField = (field, value) => {
    this.mappingForm = {
      ...this.mappingForm,
      fields: { ...this.mappingForm.fields, [field]: value },
    };
  };

  @action
  updateMappingMeta = (key, value) => {
    this.mappingForm = { ...this.mappingForm, [key]: value };
  };

  @action
  applyMappingFromForm = async () => {
    const requiredFields = ['contents', 'goodsPt', 'platformProductId', 'writerAt', 'writerId', 'writerName'];
    const missing = requiredFields.filter(f => !this.mappingForm.fields[f]);
    if (missing.length > 0) {
      const labels = {
        contents: '리뷰 내용', goodsPt: '평점', platformProductId: '상품 번호',
        writerAt: '작성일', writerId: '작성자 ID', writerName: '작성자 이름',
      };
      alert('다음 필수 항목을 매칭해 주세요:\n- ' + missing.map(f => labels[f]).join('\n- '));
      return;
    }

    const mapping = {
      name: (this.mappingForm.name || '').trim() || `양식 ${moment().format('YYYY-MM-DD HH:mm')}`,
      columnSignature: this.computeColumnSignature(this.parsedHeaders),
      ratingScale: this.mappingForm.ratingScale,
      mapping: { ...this.mappingForm.fields },
    };

    if (this.mappingForm.saveAfterApply) {
      // 동일 시그니처가 있으면 기존 ID로 덮어쓰기, 없으면 신규 생성
      const existing = this.savedMappings.find(m => m.columnSignature === mapping.columnSignature);
      if (existing) {
        mapping._id = existing._id;
      }
      const saved = await this.saveMappingToServer(mapping);
      if (saved) {
        toast.success(`양식이 저장되었습니다: ${mapping.name}`);
      }
    }

    this.applyMapping(mapping);
    this.closeMappingModal();
  };

  @action
  applyMapping = (mapping) => {
    this.currentMapping = mapping;
    const transformed = this.parsedRows.map(row => {
      const newRow = {};
      Object.entries(mapping.mapping).forEach(([targetField, sourceCol]) => {
        if (!sourceCol) return;
        let val = row[sourceCol];
        if (val === undefined || val === null || val === '') return;

        if (targetField === 'goodsPt' || targetField === 'deliveryPt') {
          const num = parseFloat(val);
          if (!isNaN(num)) {
            val = mapping.ratingScale === '5' ? Math.round(num * 20) : Math.round(num);
            if (val > 100) val = 100;
            if (val < 0) val = 0;
          }
        } else if (targetField === 'writerAt') {
          val = this.parseExcelDateMaybe(val);
        }

        newRow[targetField] = val;
      });
      return newRow;
    });

    const addData = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      platform: this.store.platform,
      fromWrite: 'file',
      displayStatus: 2,
      isSecret: false,
      isShow: true,
      isMobile: false,
      isDelete: false,
      deliveryPt: 100,
      compContents: '',
      isMember: false,
      isGuest: true,
      isAdmin: true,
      writerPw: this.teamUser.emailId,
      createdAt: moment()._d,
      orderStatus: 95,
    };
    this.listParams.searchParams = { platformProductIds: [] };
    this.myRecombinationData(transformed, addData);
  };

  @action
  useSavedMapping = (mapping) => {
    const sig = this.computeColumnSignature(this.parsedHeaders);
    if (sig !== mapping.columnSignature) {
      if (!window.confirm('현재 파일의 컬럼 구성이 저장된 양식과 다릅니다. 그래도 적용하시겠습니까?\n(매칭이 안 되는 컬럼은 비어있게 됩니다)')) return;
    }
    this.applyMapping(mapping);
    this.closeMappingModal();
    toast.success(`"${mapping.name}" 양식이 적용되었습니다.`);
  };

  // === 상품 검색 모달 ===
  _productSearchTimer = null;

  @action
  openProductSearchModal = (index) => {
    const item = this.list[index];
    if (!item) return;
    const oldId = item.platformProductId || '';
    const matchCount = this.list.filter(r =>
      r.platformProductId === oldId && !this.goodList[r.platformProductId]
    ).length;
    this.productSearchModal = {
      isOpen: true,
      targetIndex: index,
      oldProductId: oldId,
      query: '',
      results: [],
      isSearching: false,
      applyToAll: matchCount > 1,
      matchCount: matchCount,
    };
  };

  @action
  closeProductSearchModal = () => {
    this.productSearchModal = { ...this.productSearchModal, isOpen: false };
    if (this._productSearchTimer) {
      clearTimeout(this._productSearchTimer);
      this._productSearchTimer = null;
    }
  };

  @action
  updateProductSearchQuery = (query) => {
    this.productSearchModal = { ...this.productSearchModal, query };
    if (this._productSearchTimer) clearTimeout(this._productSearchTimer);
    this._productSearchTimer = setTimeout(() => {
      this.searchProducts(query);
    }, 300);
  };

  @action
  toggleProductSearchApplyAll = () => {
    this.productSearchModal = {
      ...this.productSearchModal,
      applyToAll: !this.productSearchModal.applyToAll,
    };
  };

  searchProducts = async (query) => {
    const _this = this;
    const trimmed = (query || '').trim();

    // 로컬 goodList 우선 검색 (이미 캐시된 상품)
    const lower = trimmed.toLowerCase();
    const localResults = Object.values(this.goodList || {}).filter(p => {
      if (!p) return false;
      const name = String(p.productName || '').toLowerCase();
      const id = String(p.platformProductId || '').toLowerCase();
      if (!trimmed) return true;
      return name.includes(lower) || id.includes(lower);
    }).slice(0, 50);

    this.productSearchModal = {
      ...this.productSearchModal,
      results: localResults,
      isSearching: true,
    };

    try {
      const params = {
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        page: 1,
        limit: 50,
        searchParams: trimmed ? { keyword: trimmed } : {},
      };
      const res = await this.props.getProductList(params);
      const apiResults = (res && res.docs) ? res.docs : [];
      // 로컬 결과와 API 결과 병합 (중복 제거)
      const merged = [];
      const seen = new Set();
      const push = (arr) => arr.forEach(p => {
        const id = String(p.platformProductId);
        if (id && !seen.has(id)) {
          seen.add(id);
          merged.push(p);
        }
      });
      push(apiResults);
      push(localResults);
      _this.productSearchModal = {
        ..._this.productSearchModal,
        results: merged,
        isSearching: false,
      };
    } catch (e) {
      console.error('상품 검색 실패:', e);
      _this.productSearchModal = {
        ..._this.productSearchModal,
        isSearching: false,
      };
    }
  };

  @action
  selectProductFromSearch = (product) => {
    const modal = this.productSearchModal;
    if (!product || !product.platformProductId) return;

    const newProductId = String(product.platformProductId).trim();
    const oldId = modal.oldProductId;

    // goodList에 캐시 (기존에 없으면)
    if (!this.goodList[newProductId]) {
      this.goodList[newProductId] = product;
    }

    const rebuildProductId = (r) => {
      if (r.shopNo === 1) {
        return r.platform + '_' + r.store_id + '_' + newProductId;
      }
      return r.platform + '_' + r.store_id + '_' + r.shopNo + '_' + newProductId;
    };

    let updatedCount = 0;
    if (modal.applyToAll && modal.matchCount > 1) {
      // 같은 oldId를 가진 모든 미매칭 리뷰에 일괄 적용
      this.list.forEach((r) => {
        if (!r) return;
        if (r.platformProductId === oldId) {
          r.platformProductId = newProductId;
          r.product_id = rebuildProductId(r);
          r.orderProductName = product.productName;
          updatedCount++;
        }
      });
      toast.success(`${updatedCount}건의 리뷰에 상품이 적용되었습니다: ${product.productName || newProductId}`);
    } else {
      const idx = modal.targetIndex;
      const r = this.list[idx];
      if (r) {
        r.platformProductId = newProductId;
        r.product_id = rebuildProductId(r);
        r.orderProductName = product.productName;
        updatedCount = 1;
        toast.success(`상품이 선택되었습니다: ${product.productName || newProductId}`);
      }
    }

    this.closeProductSearchModal();
  };

  // 엑셀 컬럼 알파벳 (A, B, ..., Z, AA, AB, ...)
  getColumnLetter = (i) => {
    let s = '';
    let n = i;
    while (n >= 0) {
      s = String.fromCharCode(65 + (n % 26)) + s;
      n = Math.floor(n / 26) - 1;
    }
    return s;
  };

  // 컬럼명 → 매칭된 필드명 (역방향 맵)
  getColumnFieldMap = () => {
    const map = {};
    Object.entries(this.mappingForm.fields).forEach(([f, c]) => {
      if (c) map[c] = f;
    });
    return map;
  };

  // 컬럼 → 필드 할당 (다른 컬럼에 같은 필드가 있으면 해제)
  @action
  assignFieldToColumn = (column, field) => {
    const newFields = { ...this.mappingForm.fields };
    // 이 컬럼에 기존 매칭 해제
    Object.keys(newFields).forEach(f => {
      if (newFields[f] === column) newFields[f] = '';
    });
    // 새 필드 할당 (같은 필드가 다른 컬럼에 있으면 자동 교체)
    if (field) newFields[field] = column;
    this.mappingForm = { ...this.mappingForm, fields: newFields };
    this.openDropdownColumn = null;
    this.dropdownSearch = '';
    // 사용자가 수동으로 변경한 필드는 자동매칭 표시 제거
    if (field) {
      const next = { ...this.autoMatchedFields };
      delete next[field];
      this.autoMatchedFields = next;
    }
  };

  @action
  toggleColumnDropdown = (column, event) => {
    if (this.openDropdownColumn === column) {
      this.openDropdownColumn = null;
      this.dropdownSearch = '';
      this.dropdownAlign = 'center';
      return;
    }
    this.openDropdownColumn = column;
    this.dropdownSearch = '';
    // 먼저 기본값으로 열고, 다음 프레임에 실제 위치 측정해서 정렬 확정
    this.dropdownAlign = 'center';
    const chipEl = event && event.currentTarget ? event.currentTarget : null;
    if (chipEl && typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => this.computeDropdownAlign(chipEl));
    }
  };

  @action
  computeDropdownAlign = (chipEl) => {
    if (!chipEl) return;
    const scrollEl = document.querySelector('.rmw-cmm__sheet-scroll');
    if (!scrollEl) return;
    const chipRect = chipEl.getBoundingClientRect();
    const scrollRect = scrollEl.getBoundingClientRect();
    const DROPDOWN_W = 240;
    const MARGIN = 12;
    const chipCenterX = chipRect.left + chipRect.width / 2;
    const leftIfCentered = chipCenterX - DROPDOWN_W / 2;
    const rightIfCentered = chipCenterX + DROPDOWN_W / 2;
    let align = 'center';
    if (leftIfCentered < scrollRect.left + MARGIN) {
      align = 'left';
    } else if (rightIfCentered > scrollRect.right - MARGIN) {
      align = 'right';
    }
    this.dropdownAlign = align;
  };

  @action
  setDropdownSearch = (val) => {
    this.dropdownSearch = val;
  };

  // 외부 클릭 / ESC 시 드롭다운 닫기
  handleGlobalMouseDown = (e) => {
    if (!this.openDropdownColumn) return;
    if (e.target && e.target.closest && (
      e.target.closest('.rmw-cmm-dropdown') ||
      e.target.closest('.rmw-cmm-chip')
    )) return;
    this.openDropdownColumn = null;
  };

  handleGlobalKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (this.openDropdownColumn) {
        this.openDropdownColumn = null;
      } else if (this.isMappingModalOpen) {
        this.closeMappingModal();
      }
    }
  };

  // 드래그 앤 드롭 (필드 칩 → 컬럼)
  handleFieldDragStart = (e, field) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', field);
  };

  @action
  handleColumnDragOver = (e, column) => {
    if (e.dataTransfer && e.dataTransfer.types.includes('text/plain')) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      this.dragOverColumn = column;
    }
  };

  @action
  handleColumnDragLeave = (e, column) => {
    if (this.dragOverColumn === column) this.dragOverColumn = null;
  };

  @action
  handleColumnDrop = (e, column) => {
    e.preventDefault();
    const field = e.dataTransfer.getData('text/plain');
    if (field) this.assignFieldToColumn(column, field);
    this.dragOverColumn = null;
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleGlobalMouseDown);
    document.addEventListener('keydown', this.handleGlobalKeyDown);
    // 페이지 가이드 — 첫 방문 시 1회 자동 시작(미열람 시). 위저드 렌더 후 약간 지연.
    setTimeout(() => guideManager.maybeAutoStart('reviewMassWrite', { storeId: this.store && this.store._id }), 600);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleGlobalMouseDown);
    document.removeEventListener('keydown', this.handleGlobalKeyDown);
  }

  @action
  handleDragOverUpload = (event, index) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    this.dragUploadIndex = index;
  };

  @action
  handleDragLeaveUpload = (event, index) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.dragUploadIndex === index) {
      this.dragUploadIndex = null;
    }
  };

  @action
  handleDropUpload = async (event, index) => {
    event.preventDefault();
    event.stopPropagation();
    this.dragUploadIndex = null;

    const files = Array.from(event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : []);
    const imageFiles = files.filter(file => file.type && file.type.startsWith('image/'));

    if (imageFiles.length === 0) {
      toast('이미지 파일만 업로드할 수 있습니다.');
      return;
    }

    await this.handleImageUpload(undefined, index, imageFiles);
  };

  uploadBase64Image = (base64Image) => {
    return new Promise((resolve, reject) => {
      this.props.base64UploadImages({
        store_id: this.teamUser.selStore_id,
        base64Imgs: [{ image: base64Image }]
      }, (res) => {
        if (res && res.errors && res.errors.length > 0) {
          reject(new Error(res.errors[0].message));
        } else {
          resolve(res);
        }
      });
    });
  };

  loadImageElement = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (error) => reject(error);
      img.src = src;
    });
  };

  generateThumbnailDataUrl = (img) => {
    const maxSize = 500;
    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
    const width = Math.max(1, Math.round(img.width * scale));
    const height = Math.max(1, Math.round(img.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;              // 보간 활성화
    ctx.imageSmoothingQuality = 'high';            // 고품질 보간
    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL('image/jpeg', 0.92);   // 1 대신 0.9~0.95 정도 권장
  };


  @action
  init = async (key) => {
    if(this.props.isLogin) {
      this.reviewSize = 501;
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.permissions = this.props.me.permissions;

      this.isUse = false;
      if(this.teamUser.hasReviewWriteAddon) {
        this.isUse = true;
      }

      // 유의사항 동의 확인 (sessionStorage)
      this.checkWarningAgreement();

      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      //this.listParams.teamUserId = this.teamUser.id;

      // 사용자 정의 양식 매핑 로드
      this.loadSavedMappings();

      //url params
      for (const key of this.urlParams.keys()) {
        if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
          this.listParams[key] = parseInt(this.urlParams.get(key));
        }
        else {
          this.searchParams[key] = this.urlParams.get(key);
        }
      }

      //this.getProductList();

    }

  };


  getProductList = async() => {
    if(this.listParams.store_id) {

      let storageKey = 'goodList_' + this.store.platformId + "_" + moment().format('YYYY-MM');
      // let tempGoodList = await Storage.getObject(storageKey);// todo 임시로 강제로 api 호출 시킴
      let tempGoodList = {};
      if(!tempGoodList.totalDocs || tempGoodList.totalDocs === 0) {
        for (let i = 0; i < localStorage.length; i++) {
          if(localStorage.key(i).indexOf("goodList_" + this.store.platformId) > -1 ) {
            localStorage.removeItem(localStorage.key(i));
          }
        }
        //this.listParams.searchParams = this.searchParams;
        tempGoodList = await this.props.getProductList(this.listParams);
        Storage.setObject(storageKey, tempGoodList);
      }
      this.goodList = _.indexBy(tempGoodList.docs, 'platformProductId');
      this.isLoading = false;
    }
    else {
      //console.log('null store_id');
    }
  };


  handleFileUpload = async (event) => {
    let _this = this;
    this.isLoading = true;
    const file = event.target.files[0];
    if (file) {
      if (!this.selectedFile) {
        this.selectedFile = { name: file.name, size: file.size };
      }

      // 사용자 정의 양식 모드 → 매핑 플로우로 분기
      if (this.filePlatform === 'custom') {
        this.parseCustomFile(file);
        return;
      }

      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (fileExtension === 'csv') {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            console.log(result.data)
            _this.toMyData(result.data);
          },
          error: (error) => {
            console.error('CSV 파싱 오류:', error);
          },
        });
      } else if (fileExtension === 'xlsx' || fileExtension === 'xls') {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          let jsonData = XLSX.utils.sheet_to_json(worksheet);

          // writerAt 필드에 날짜 숫자값이 있을 경우 -> yyyy-mm-dd 형식으로 변환
          jsonData = jsonData.map(row => {
            // writerAt 변환 처리
            if (row.writerAt && typeof row.writerAt === 'number') {
              const dateObj = XLSX.SSF.parse_date_code(row.writerAt);
              row.writerAt = `${dateObj.y}-${String(dateObj.m).padStart(2, '0')}-${String(dateObj.d).padStart(2, '0')}`;
            }
            return row;
          });
          
          _this.toMyData(jsonData)
        };
        reader.readAsArrayBuffer(file);
      }
    }
  };

  recombinationData = async (targetModel, otherModel, arrayData, addData) => {
    let _this = this;
    let reData = [];
    let platform = addData.platform ? addData.platform : (addData.fromWrite ? addData.fromWrite : '');
    for(let i in arrayData) {
      let row = arrayData[i];

      if(!row.parent_article_no) {
        let product_id, userOrder_id;

        let newRow = {
          exReview_id: row.review_id,
          shopNo: row.shop_no,
          platform:platform,
          syncFrom:platform,
          fromWrite: addData.fromWrite ? addData.fromWrite : platform,
          reviewType: "text"
        };


        for(let j in targetModel) {
          let myKey = targetModel[j];
          let otherKey = otherModel[myKey];

          if(myKey) {
            if(myKey === 'product_id'){
              newRow[myKey] = product_id;
            }
            if(myKey === 'userOrder_id' && userOrder_id) {
              newRow[myKey] = userOrder_id;
            }
            // if(myKey === 'platformProductId') {
            //   newRow[myKey] = platformProductId;
            // }
            // else if(myKey === 'platformData') {
            //   newRow[myKey] = row;
            //   if(addData.commentsObj && addData.commentsObj[row.article_no]) {
            //     newRow.comment = addData.commentsObj[row.article_no];
            //   }
            // }
            else if(myKey === 'platformImages') {
              if(row[otherKey] && row[otherKey].length > 0) {
                newRow[myKey] = row[otherKey];
                newRow["reviewType"] = "image";
              }
              else if(row['attach_file_urls'] && row['attach_file_urls'].length > 0) {
                newRow[myKey] = row['attach_file_urls'];
                newRow["reviewType"] = "image";
              }

            }
            else if(myKey === 'images') {
              newRow[myKey] = [];
              if (!newRow.thumbs) {
                newRow.thumbs = [];
              }
              for(let i in otherKey) {
                if(row[otherKey[i]]) {
                  const imageUrl = row[otherKey[i]];
                  const imageName = imageUrl.split('/').pop();
                  newRow[myKey].push({url: imageUrl, name: imageName});
                  newRow.thumbs.push({url: imageUrl, name: `${imageName}_thumb`});
                  newRow["reviewType"] = "image";
                }
              }
            }
            else if(myKey === 'movies') {
              newRow[myKey] = [];
              for(let i in otherKey) {
                if(row[otherKey[i]]) {
                  newRow[myKey].push({url: row[otherKey[i]]});
                  newRow["reviewType"] = "movie";
                }
              }
            }
            else if(myKey === 'isGuest') {
              newRow[myKey] = (!row['member_id']);
            }
            else if(myKey === 'isMember') {
              if(platform === 'nhnc') {
                newRow[myKey] = !!(row['member_id']);
              }
              else if(platform === 'cafe24') {

                newRow[myKey] = !!(row['member_id']);
              }
            }
            else if(addData[myKey]) {
              newRow[myKey] = addData[myKey];
            }
            else if(row[otherKey]) {

              if(myKey === 'isSecret' || myKey === 'isShow' || myKey === 'isMobile' || myKey === 'isAdult' || myKey === 'hasStock' || myKey === 'isDelete') {
                if(myKey === 'isMobile') {
                  newRow[myKey] = (row[otherKey] === 'M');
                }
                else {
                  newRow[myKey] = (row[otherKey] === 'T');
                }
              }
              else if(myKey === 'goodsPt') {
                let pt = row[otherKey] * 20;
                if (pt > 100) pt = 100;
                if (pt < 0) pt = 0;
                newRow[myKey] = pt;
              }
              else if(myKey === 'contents') {
                newRow[myKey] = row[otherKey] ? row[otherKey].replace(/<\/?p>/gi, "\n") : "";
              }
              else if(myKey === 'price') {
                newRow[myKey] = row[otherKey] > 0 ?  row[otherKey] : row['price'];
              }
              else if(myKey === 'writerName') {
                newRow[myKey] = row[otherKey];
              }

              else {
                newRow[myKey] = row[otherKey];
              }
            }
            else {

              if(myKey === 'writerName') {
                newRow[myKey] = "-";
              }
              //console.log(myKey)
            }
          }
          else {
            //console.log(myKey)
          }

        }

        if(newRow.shopNo === 1) {
          newRow.product_id = platform + '_' + newRow.store_id + '_' + newRow.platformProductId;
        }
        else {
          newRow.product_id = platform + "_" + newRow.store_id + "_"  + newRow.shopNo + "_" + newRow.platformProductId;
        }

        if(!_this.listParams.searchParams.product_ids) {
          _this.listParams.searchParams.product_ids = [];
        }
       _this.listParams.searchParams.product_ids.push(newRow.product_id);
        if(newRow.platformProductId_ref) {
          newRow.platformProductId_ref += newRow.platformProductId;
          newRow._id = newRow.platformProductId_ref;
        }
        reData.push(newRow);
        this.exImgList = _.filter(reData, function(item) {
          return item.images && item.images.length > 0;
        });

      }
    }

    // let myReview = ['store_id', 'platformArticleNo', 'shopNo', 'product_id', 'userOrder_id', 'platformProductId', 'platformOrderId', 'fromWrite', 'platformData', 'platformImages', 'platformUserId', 'writerName', 'writerId', 'writerEmail', 'writerPw', 'writerIp', 'subject', 'contents', 'images', 'movies', 'isSecret', 'isShow', 'isMobile',
    //   'hit', 'memoCnt', 'goodsPt', 'point', 'pointReason', 'payMileageStatus', 'payBonusMileageStatus', 'orderStatus', 'deliveryPt', 'isMember', 'isGuest', 'isAdmin', 'isDelete', 'uploadPath', 'writerAt', 'displayAt'];

    reData = reData.filter((item, i) => {;
      if (!item.platformProductId || !item.contents || !item.writerName || !item.goodsPt || !item.writerAt) {
        item.error = {};
        if (!item.platformProductId) {
          item.error.platformProductId = "상품번호를 확인해 주세요!";
        }
        if (!item.contents) {
          item.error.contents = "리뷰 내용을 확인해 주세요!";
        }
        if (!item.writerName) {
          item.error.writerName = "작성자를 확인해 주세요!";
        }
        if (!item.goodsPt) {
          item.error.goodsPt = "평점을 확인해 주세요!";
        }
        if(!item.writerAt) {
          item.error.writerAt = "작성일을 확인해 주세요!";
        }
        _this.errData.push(item);
        return false;
      }
      else {
        return true;
      }
    });

    this.isLoading = false;
    this.list = reData
    this.list.forEach(item => {
      if (!item) return;
      if (item.images && item.images.length > 0) {
        if (!item.thumbs || item.thumbs.length !== item.images.length) {
          item.thumbs = item.images.map((img, idx) => ({
            name: (img && img.name) ? `${img.name}_thumb` : `image_${idx}_thumb`,
            url: img && img.url ? img.url : ''
          }));
        }
      } else if (!item.thumbs) {
        item.thumbs = [];
      }
    });
    this.exImgList = _.filter(reData, function(item) {
      return item.images && item.images.length > 0;
    });
    this.exImgList.forEach(item => {
      if (!item) return;
      if (item.images && item.images.length > 0) {
        if (!item.thumbs || item.thumbs.length !== item.images.length) {
          item.thumbs = item.images.map((img, idx) => ({
            name: (img && img.name) ? `${img.name}_thumb` : `image_${idx}_thumb`,
            url: img && img.url ? img.url : ''
          }));
        }
      } else if (!item.thumbs) {
        item.thumbs = [];
      }
    });

    if (this.list && this.list.length > 0) {
      this.advanceStep(2);
    }
  }

  myRecombinationData = async (data, addData) => {
    let _this = this;
    data = data.filter(item => {
      if (item.error) {
        _this.errData.push(item);
        return false;
      }
      return true;
    });
    let updatedReviews = _.map(data, function(review) {
      // images_1 ~ images_5 → images 배열로 병합
      let imageList = [];
      for (let i = 1; i <= 5; i++) {
        let key = `images_${i}`;
        if (review[key]) {
          try {
            if (review[key] !=="") {
              imageList = imageList.concat( {name:review[key].split('/').pop(), url: review[key]} );
            }
          } catch (e) {}
        }
        delete review[key];
      }
      review.images = imageList;
      review.thumbs = imageList
          .filter(img => img && img.url)
          .map((img, idx) => ({
            name: (img.name) ? `${img.name}_thumb` : `image_${idx}_thumb`,
            url: img.url
          }));
      if(review.images.length > 0) review.reviewType = "image";

      // movies_1 ~ movies_5 → movies 배열로 병합
      let movieList = [];
      for (let i = 1; i <= 5; i++) {
        let key = `movies_${i}`;
        if (review[key]) {
          try {
            if (review[key] !=="") {
              movieList = movieList.concat( {name:review[key].split('/').pop(), url: review[key]} );
            }
          } catch (e) {}
        }
        delete review[key];
      }
      review.movies = movieList;
      if(review.movies.length > 0) review.reviewType = "movie";

      if(!review.reviewType) review.reviewType = "text";

      // 숫자형으로 변환할 키들
      ['deliveryPt', 'displayStatus', 'goodsPt', 'likeCount', 'paidMileage'].forEach(function(key) {
        if (review[key] !== undefined) {
          review[key] = parseInt(review[key], 10) || 0;
          if (key === 'goodsPt' || key === 'deliveryPt') {
            if (review[key] > 100) review[key] = 100;
            if (review[key] < 0) review[key] = 0;
          }
        }
      });


      // 빈 문자열, null, undefined 제거
      let cleanedReview = _.omit(review, function(value) {
        return (typeof value === 'string' && value.trim() === '') || value === null || value === undefined;
      });

      // addData 병합
      review = _.defaults({}, cleanedReview, addData);
      review.writerAt = typeof review.writerAt === "string" ?
          (review.writerAt.includes("0000-00-00") ? null : moment(review.writerAt.trim())._d) :
          review.writerAt;
      

      if(review.platformProductId) {
        if(review.shopNo === 1) {
          review.product_id = review.platform + "_" + review.store_id + "_" + review.platformProductId;
        }
        else {
          review.product_id = review.platform + "_" + review.store_id + "_"  + review.shopNo + "_" + review.platformProductId;
        }

        if(_this.listParams.searchParams.platformProductIds.indexOf(review.platformProductId) === -1) {
          _this.listParams.searchParams.platformProductIds.push(review.platformProductId);
        }

      }
      if((review.writerId && review.writerId !== "") || (review.platformUserId && review.platformUserId !== "")) review.isGuest = false; review.isMember = true;
      if(review.writerAt || review.writerAt !== "") review.displayAt = moment(review.writerAt)._d;
      if(!review.writerId || review.writerId === "") review.writerId = "nowriterid";
      // if(review.deliveryPt > 0) {
      //   if(review.deliveryPt > 80) {
      //     review.compContents = review.contents + '\n 배송은 최고예요 😍';
      //   }
      //   else if(review.deliveryPt > 60){
      //     review.compContents = review.contents + '\n 배송은좋아요 😍';
      //   }
      //   else if(review.deliveryPt > 40){
      //     review.compContents = review.contents + '\n 배송은 만족해요';
      //   }
      //   else if(review.deliveryPt > 20){
      //     review.compContents = review.contents + '\n 배송은 아쉬워요';
      //   }
      //   else if(review.deliveryPt > 0){
      //     review.compContents = review.contents + '\n 배송은 별로에요';
      //   }
      // }
      return review;
    });


    this.getProductList();


    this.isLoading = false;
    this.list = updatedReviews;
    console.log(this.list)

    if (this.list && this.list.length > 0) {
      this.advanceStep(2);
    }

    // this.exImgList = _.filter(reData, function(item) {
    //   return item.images && item.images.length > 0;
    // });
    // console.log(this.exImgList)
  }





  toMyData = async (data) => {
    let _this = this;
    _this.listParams.searchParams = {
      platformProductIds: []
    };
    if(data.length > _this.reviewSize) {
      alert(_this.reviewSize + "개 이상의 리뷰를 한번에 등록할 수 없습니다.\n파일을 나눠서 등록 해주세요.");
      window.location.reload();
      return false;
    }
    // data = data.filter(item => {
    //   if (item.error) {
    //     _this.errData.push(item);
    //     return false;
    //   }
    //   return true;
    // });
    //
    // console.log(_this.errData)

    // store_id: this.teamUser.selStore_id,
    //     shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    let myReview = ['store_id', 'platformArticleNo', 'shopNo', 'product_id', 'userOrder_id', 'platformProductId', 'platformOrderId', 'fromWrite', 'platformData', 'platformImages', 'platformUserId', 'writerName', 'writerId', 'writerEmail', 'writerPw', 'writerIp', 'subject', 'contents', 'images', 'movies', 'isSecret', 'isShow', 'isMobile',
      'hit', 'memoCnt', 'goodsPt', 'point', 'pointReason', 'payMileageStatus', 'payBonusMileageStatus', 'orderStatus', 'deliveryPt', 'isMember', 'isGuest', 'isAdmin', 'isDelete', 'uploadPath', 'writerAt', 'displayAt'];

    let smartstore = {
      // userOrder_id: 'order_id',
      platformProductId: '상품번호',
      // platformUserId: 'user_id',
      // platformOrderId: 'order_id',
      // platformImages: 'image_url0',
      writerName: '등록자',
      writerId: '등록자',
      writerAt: '리뷰등록일',
      displayAt: '리뷰등록일',
      subject: '상품명',
      contents: '리뷰상세내용',
      goodsPt: '구매자평점',
      // mileage: 'reward_amount',
      images: ['포토/영상'],
      //movies: ['video_url0', 'video_url1'],
    }

    let vreview = {
      userOrder_id: 'order_id',
      platformProductId: 'product_id',
      platformUserId: 'user_id',
      platformOrderId: 'order_id',
      // platformImages: 'image_url0',
      writerName: 'author_name',
      writerId: 'user_id',
      writerAt: 'created_at',
      displayAt: 'created_at',
      subject: 'title',
      contents: 'text',
      goodsPt: 'rating',
      mileage: 'reward_amount',
      images: ['image_url0', 'image_url1', 'image_url2', 'image_url3'],
      //movies: ['video_url0', 'video_url1'],
    }



    let addData = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      platform: this.store.platform,
      fromWrite: "file",
      displayStatus: 2,
      isSecret: false,
      isShow: true,
      isMobile: false,
      isDelete: false,
      deliveryPt: 100,
      compContents: "",
      isMember: false,
      isGuest: true,
      isAdmin: true,
      writerPw: this.teamUser.emailId,
      createdAt: moment()._d,
      orderStatus: 95,
    }

    switch (this.filePlatform) {
      case 'smartstore':
        this.recombinationData(myReview, smartstore, data, addData);
        return false;
      case 'vreview':
        this.getProductList();
        this.recombinationData(myReview, vreview, data, addData);
        return false;
      default:
        this.myRecombinationData(data, addData);
        return false;
    }

  };

  uploadReviewExImgs = async () => {
    let _this = this;

    if (this.exImgList && this.exImgList.length > 0) {
      const chunkSize = 1;
      const total = this.exImgList.length;

      // 배열을 10개 단위로 잘라서 처리
      const chunks = [];
      for (let i = 0; i < total; i += chunkSize) {
        chunks.push(this.exImgList.slice(i, i + chunkSize));
      }

      _this.uploadImgStatus.completed = 0;
      _this.uploadImgStatus.total = total;
      let completed = 0;

      _this.exImgList = [];
      for (let i = 0; i < chunks.length; i++) {
        const updateData = {
          store_id: this.store._id,
          shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
          reviews: chunks[i]
        };

        /* eslint-disable no-loop-func */
        // await 직렬화로 chunks[i] closure 캡쳐 안전 (chunks/i 는 매 iteration 새로 evaluated)
        await new Promise((resolve) => {
          _this.props.uploadReviewExImgs(updateData, function (res) {
            // 응답 데이터 반영
            const normalizedData = res.data.map(item => {
              if (!item) return item;
              if (item.images && item.images.length > 0) {
                const thumbs = item.thumbs && item.thumbs.length === item.images.length
                    ? item.thumbs
                    : item.images.map((img, idx) => ({
                      name: (img && img.name) ? `${img.name}_thumb` : `image_${idx}_thumb`,
                      url: img && img.url ? img.url : ''
                    }));
                return {...item, thumbs};
              }
              return {...item, thumbs: item.thumbs ? item.thumbs : []};
            });
            _this.exImgList.push(...normalizedData);
            _.each(res.data, function (item) {
              var targetItem = _.findWhere(_this.list, { exReview_id: item.exReview_id });
              if (targetItem) {
                targetItem.images = item.images;
                targetItem.platformImages = item.images;
                targetItem.thumbs = item.thumbs ? item.thumbs : (item.images ? item.images.map((img, idx) => ({
                  name: (img && img.name) ? `${img.name}_thumb` : `image_${idx}_thumb`,
                  url: img && img.url ? img.url : ''
                })) : []);
              }
            });

            // 완료된 개수 누적
            completed += chunks[i].length;
            _this.uploadImgStatus.completed = completed;
            console.log(`완료: ${completed}/${total}`);

            resolve();
          });
        });
        /* eslint-enable no-loop-func */

        // 마지막 chunk가 아니면 2초 대기 후 다음 chunk 실행
        if (i < chunks.length - 1) {
          await new Promise((r) => setTimeout(r, 1000));
        }
      }
    }
  };

  // 이미지 삭제 함수
  removeImage = (reviewIndex, imageIndex) => {
    this.list[reviewIndex].images.splice(imageIndex, 1);
    if (this.list[reviewIndex].thumbs && this.list[reviewIndex].thumbs.length > imageIndex) {
      this.list[reviewIndex].thumbs.splice(imageIndex, 1);
    }
    // 이미지가 모두 삭제되면 reviewType을 text로 변경
    if (this.list[reviewIndex].images.length === 0) {
      this.list[reviewIndex].reviewType = "text";
      this.list[reviewIndex].thumbs = [];
    }
  }

  // 이미지 업로드 함수
  handleImageUpload = async (event, reviewIndex, overrideFiles) => {
    const files = Array.isArray(overrideFiles) ? overrideFiles : Array.from(event && event.target && event.target.files ? event.target.files : []);
    if (files.length === 0) {
      if (event && event.target) {
        event.target.value = '';
      }
      return;
    }

    this.isUploading = true;

    try {
      for (const file of files) {
        const allowedExtensions = ["image/"];
        const fileType = file.type;

        if (!allowedExtensions.some(ext => fileType.startsWith(ext))) {
          alert("이미지 파일만 선택 가능합니다.");
          if (event && event.target) {
            event.target.value = "";
          }
          this.isUploading = false;
          return;
        }

        if (file.size / 1000000 > 60) {
          alert('파일 용량이 60MB 이하만 등록이 가능합니다.');
          this.isUploading = false;
          return;
        }

        await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = async (readerEvent) => {
            try {
              let chgFileName = this.generateUniqueFilename();
              const renamedFile = new File([file], chgFileName + '.' + file.name.split('.').pop(), {
                type: file.type
              });

              const formData = new FormData();
              formData.append("file", renamedFile);

              let fetchHeader = process.env.NODE_ENV === "development" ? {'X-Target-Server': ''} : {};

              const response = await fetch(process.env.NODE_ENV === "development" ?
                'https://orpapi.onreview.co.kr/api/upload' :
                'https://orpapi.onreview.co.kr/api/upload', {
                method: 'POST',
                body: formData,
                headers: fetchHeader
              });

              const data = await response.json();

              let toUploadParams = {
                store_id: this.store._id,
                imagesUrls: [data[0].fullPath]
              };

              this.props.cafe24UploadFiles(toUploadParams, async (res) => {
                try {
                  if (!this.list[reviewIndex].images) {
                    this.list[reviewIndex].images = [];
                  }
                  const imageUrl = res.files[0].url;
                  this.list[reviewIndex].images.push({
                    name: renamedFile.name,
                    url: imageUrl
                  });
                  if (!this.list[reviewIndex].thumbs) {
                    this.list[reviewIndex].thumbs = [];
                  }

                  let thumbUrl = imageUrl;
                  try {
                    const dataUrl = readerEvent.target.result;
                    const imgElement = await this.loadImageElement(dataUrl);
                    const thumbDataUrl = this.generateThumbnailDataUrl(imgElement);
                    const uploadedThumb = await this.uploadBase64Image(thumbDataUrl);
                    if (uploadedThumb && uploadedThumb.images && uploadedThumb.images[0]) {
                      thumbUrl = uploadedThumb.images[0].path || thumbUrl;
                    }
                  } catch (thumbError) {
                    console.error('썸네일 업로드 실패:', thumbError);
                  }

                  this.list[reviewIndex].thumbs.push({
                    name: `${renamedFile.name}_thumb`,
                    url: thumbUrl
                  });
                  this.list[reviewIndex].reviewType = "image";
                  resolve();
                } catch (cbError) {
                  reject(cbError);
                  return;
                }
              });

            } catch (error) {
              reject(error);
            }
          };
          reader.readAsDataURL(file);
        });
      }

      toast.success('이미지가 성공적으로 업로드되었습니다.');
    } catch (error) {
      toast.error('이미지 업로드 중 오류가 발생했습니다.');
      console.error('이미지 업로드 오류:', error);
    } finally {
      this.isUploading = false;
      if (event && event.target) {
        event.target.value = '';
      }
    }
  }

  // 고유한 파일명 생성 함수
  generateUniqueFilename = () => {
    const now = new Date();
    const timestamp = now.getTime();
    const random = Math.floor(Math.random() * 1000);
    return `${timestamp}_${random}`;
  }

  // 상품번호 업데이트 함수
  updateProductId = async (reviewIndex, newProductId) => {
    if (!newProductId || newProductId.trim() === '') {
      alert('상품번호를 입력해주세요.');
      return;
    }

    // 리뷰 아이템의 상품번호 업데이트
    this.list[reviewIndex].platformProductId = newProductId.trim();

    // product_id 재생성
    if (this.list[reviewIndex].shopNo === 1) {
      this.list[reviewIndex].product_id = this.list[reviewIndex].platform + "_" + this.list[reviewIndex].store_id + "_" + newProductId.trim();
    } else {
      this.list[reviewIndex].product_id = this.list[reviewIndex].platform + "_" + this.list[reviewIndex].store_id + "_" + this.list[reviewIndex].shopNo + "_" + newProductId.trim();
    }

    // 새로운 상품번호가 goodList에 없는 경우 상품 정보 다시 가져오기
    if (!this.goodList[newProductId.trim()]) {
      this.isLoading = true;

      // searchParams에 새로운 상품번호 추가
      if (!this.listParams.searchParams) {
        this.listParams.searchParams = {};
      }
      if (!this.listParams.searchParams.platformProductIds) {
        this.listParams.searchParams.platformProductIds = [];
      }
      if (this.listParams.searchParams.platformProductIds.indexOf(newProductId.trim()) === -1) {
        this.listParams.searchParams.platformProductIds.push(newProductId.trim());
      }

      // 기존 캐시 삭제 및 새로운 상품 정보 가져오기
      let storageKey = 'goodList_' + this.store.platformId + "_" + moment().format('YYYY-MM');
      for (let i = 0; i < localStorage.length; i++) {
        if(localStorage.key(i).indexOf("goodList_" + this.store.platformId) > -1 ) {
          localStorage.removeItem(localStorage.key(i));
        }
      }

      try {
        let tempGoodList = await this.props.getProductList(this.listParams);
        Storage.setObject(storageKey, tempGoodList);
        this.goodList = _.indexBy(tempGoodList.docs, 'platformProductId');

        if (this.goodList[newProductId.trim()]) {
          // orderProductName에 상품명 추가
          this.list[reviewIndex].orderProductName = this.goodList[newProductId.trim()].productName;
          toast.success('상품번호가 업데이트되고 상품 정보를 가져왔습니다.');
        } else {
          toast.warning('상품번호가 업데이트되었지만 해당 상품 정보를 찾을 수 없습니다.');
        }
      } catch (error) {
        console.error('상품 정보 가져오기 실패:', error);
        toast.error('상품 정보를 가져오는 중 오류가 발생했습니다.');
      } finally {
        this.isLoading = false;
      }
    } else {
      toast.success('상품번호가 업데이트되었습니다.');
    }
  }

  // 리뷰 삭제 함수
  removeReview = (reviewIndex) => {
    if (window.confirm('이 리뷰를 삭제하시겠습니까?')) {
      this.list.splice(reviewIndex, 1);
      toast.success('리뷰가 삭제되었습니다.');
    }
  }

  // 필수 데이터 검증 함수
  isInvalidReview = (item) => {
    // 작성일이 Invalid Date인지 확인
    const isInvalidDate = item.writerAt && moment(item.writerAt).format() === "Invalid date";
    // 상품정보가 goodList에 없는 경우 (미매칭 상품)
    const noProduct = !item.platformProductId || !this.goodList[item.platformProductId];

    return !item.contents || !item.writerName || !item.goodsPt || !item.writerAt || isInvalidDate || noProduct;
  }

  // 유효하지 않은 리뷰 개수 확인
  getInvalidReviewCount = () => {
    return this.list.filter(item => this.isInvalidReview(item)).length;
  }

  // GraphQL 직렬화 문법 오류 위험 검사 (gql.js 한계로 역슬래시 등이 포함되면 서버에서 Syntax Error 발생)
  // 문제 필드명을 반환하거나 null
  getSyntaxRiskField = (item) => {
    const risky = (val) => {
      if (typeof val !== 'string' || !val) return false;
      // 역슬래시: JSON.stringify 직렬화 시 GraphQL 파서에서 Invalid character escape sequence 발생
      if (val.indexOf('\\') !== -1) return true;
      // '":' 시퀀스: gql.js 의 키 언쿼팅 정규식과 충돌하여 쿼리가 파손됨
      if (val.indexOf('":') !== -1) return true;
      return false;
    };
    const fields = ['contents', 'writerName', 'writerId', 'writerEmail', 'orderProductName', 'subject', 'orderProductOptions'];
    for (let f of fields) {
      if (risky(item[f])) return f;
    }
    return null;
  }

  isSyntaxRiskReview = (item) => {
    return this.getSyntaxRiskField(item) !== null;
  }

  getSyntaxRiskCount = () => {
    return this.list.filter(item => this.isSyntaxRiskReview(item)).length;
  }

  // 문법 오류 위험 리뷰 일괄 제외
  @action
  excludeSyntaxRiskReviews = () => {
    const before = this.list.length;
    this.list = this.list.filter(item => !this.isSyntaxRiskReview(item));
    const removed = before - this.list.length;
    if (removed > 0) {
      toast.success(`${removed}개의 문법 오류 위험 리뷰를 제외했습니다.`);
    }
  }

  // 편집 중인 필드가 있는지 확인
  hasEditingFields = () => {
    return Object.keys(this.editingReview).length > 0;
  }

  // 편집 모드 토글
  toggleEditMode = (reviewIndex, field) => {
    const key = `${reviewIndex}_${field}`;
    if (this.editingReview[key]) {
      delete this.editingReview[key];
    } else {
      this.editingReview[key] = true;
    }
  }

  // 편집 모드 확인
  isEditing = (reviewIndex, field) => {
    const key = `${reviewIndex}_${field}`;
    return !!this.editingReview[key];
  }

  // 리뷰 데이터 업데이트
  updateReviewField = (reviewIndex, field, value) => {
    if (field === 'goodsPt' || field === 'deliveryPt') {
      const numValue = parseInt(value, 10);
      if (isNaN(numValue) || numValue < 20 || numValue > 100 || numValue % 20 !== 0) {
        alert('평점은 20, 40, 60, 80, 100 중 하나를 입력해주세요.');
        return;
      }
      this.list[reviewIndex][field] = numValue;
    } else if (field === 'writerAt') {
      if (!value) {
        alert('작성일을 입력해주세요.');
        return;
      }
      this.list[reviewIndex][field] = moment(value)._d;
      this.list[reviewIndex].displayAt = moment(value)._d;
    } else {
      if (!value || value.trim() === '') {
        alert('값을 입력해주세요.');
        return;
      }
      this.list[reviewIndex][field] = value.trim();
    }

    // 편집 모드 종료
    const key = `${reviewIndex}_${field}`;
    delete this.editingReview[key];

    toast.success('데이터가 업데이트되었습니다.');
  }

  // 편집 취소
  cancelEdit = (reviewIndex, field) => {
    const key = `${reviewIndex}_${field}`;
    delete this.editingReview[key];
  }

  // 점수를 별점으로 변환하는 함수
  getStarRating = (score) => {
    score = score > 100 ? 100 : score;
    const stars = Math.floor(score / 20);
    // const stars = Math.min(Math.floor(score / 20), 5);

    const fullStar = '★';
    const emptyStar = '☆';
    return fullStar.repeat(stars) + emptyStar.repeat(5 - stars);
  }


  updateMassReview = async() => {
    let _this = this;
    if(!this.isUse) {
      toast.error('유료 플랜 전용 기능입니다. 결제 페이지에서 플랜을 활성화해주세요.');
      return false;
    }

    // 편집 중인 필드가 있는지 확인
    if (this.hasEditingFields()) {
      alert('편집중인 필드를 저장 또는 취소하여 편집을 완료하여 주세요.');
      return false;
    }

    // 문제 리뷰(필수 누락 + 문법 오류 위험)가 남아있으면 차단 - 버튼 비활성화와 이중 안전장치
    const invalidCount = this.getInvalidReviewCount();
    const syntaxRiskCount = this.getSyntaxRiskCount();
    if (invalidCount > 0 || syntaxRiskCount > 0) {
      alert(
        `문제가 있는 리뷰가 ${invalidCount + syntaxRiskCount}건 남아있습니다.\n` +
        (invalidCount > 0 ? `- 필수 항목 누락: ${invalidCount}건\n` : '') +
        (syntaxRiskCount > 0 ? `- 문법 오류 위험: ${syntaxRiskCount}건\n` : '') +
        `\n해당 리뷰를 수정 또는 삭제한 후 등록해주세요.`
      );
      return false;
    }

    if (!this.list || this.list.length === 0) {
      alert('등록할 리뷰가 없습니다.');
      return false;
    }

    //console.log("updateMassReview", this.list);
    const totalAttempt = this.list.length;
    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      reviews: this.list
    }
    this.isSubmitting = true;
    this.props.updateMassReview(updateData, function(res) {
      _this.isSubmitting = false;
      if(res.data && res.data.length > 0) {
        const successCount = res.data.length;
        const failCount = Math.max(0, totalAttempt - successCount);
        const imageCount = (_this.exImgList && _this.exImgList.length) ? _this.exImgList.length : 0;
        _this.registerResult = {
          success: successCount,
          fail: failCount,
          imageCount: imageCount,
          total: totalAttempt
        };
        _this.advanceStep(3);
        toast.success(`${successCount}건의 리뷰가 등록되었습니다.`);
        setTimeout(() => {
          const el = document.getElementById('rmw-step-3');
          if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
      else {
        toast.error('등록 실패하였습니다. 등록한 파일 확인 또는 상담톡으로 문의 부탁드립니다.');
      }

    });
  }

  adminCusData = async() => {
    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    }
    // console.log('updateMassReview', updateData);
    this.props.adminCusData(updateData, function(res) {
      console.log(res);

    });
  }

  onChangeSelcter = async (event, targetData) => {
    const { name, value } = event.target;
    targetData[name] = value;
  }


  render() {
    const isAdmin = this.teamUser.email === 'admin@onnomads.com' || (this.urlParams.get('super') === 'super');
    const validCount = this.getValidReviewCount();
    const invalidCount = this.getInvalidReviewCount();
    const syntaxRiskCount = this.getSyntaxRiskCount();
    const totalCount = this.list ? this.list.length : 0;
    const selectedCount = Object.keys(this.selectedRows).length;
    const isAllSelected = totalCount > 0 && selectedCount === totalCount;
    const stepDefs = [
      { n: 1, label: '파일 업로드 & 가이드' },
      { n: 2, label: '데이터 확인 & 편집' },
      { n: 3, label: '최종 등록' },
    ];

    return (
      <div className="main-content rmw-page">
        <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16}}>
          <PageTitle />
          <HelpButton tourKey="reviewMassWrite" />
        </div>

        {(this.isLogin && this.teamUser && !this.teamUser.hasReviewWriteAddon) && (
          <div className="es-paywall-banner">
            <FeatherIcon icon="lock" size="14"/>
            <span><strong>대량 등록 화면은 무료로 확인</strong>할 수 있습니다. 엑셀 업로드 / 일괄 등록은 <strong>리뷰 부스터 추가 옵션</strong>이 필요합니다.</span>
            <button type="button" className="es-paywall-banner__cta"
                    onClick={() => { window.location.href = '/inAppOrder'; }}>
              <FeatherIcon icon="credit-card" size="13"/>
              결제페이지로 이동하기
              <FeatherIcon icon="arrow-right" size="13"/>
            </button>
          </div>
        )}

        {/* 헤더 영역 */}
        <div className="rmw-header">
          <div className="rmw-header__title-area">
            <p className="rmw-header__subtitle">엑셀 파일로 리뷰를 한번에 최대 500개까지 등록할 수 있습니다.</p>
          </div>
          <div className="rmw-header__actions">
            <Link to="/reviewMassList">
              <button type="button" className="rmw-btn rmw-btn--ghost">
                <FeatherIcon icon="list" size={16} />
                <span>대량 등록 리뷰 보기</span>
              </button>
            </Link>
          </div>
        </div>

        {/* 유의사항 배너 — 동의 체크 후 닫기 (sessionStorage) */}
        {this.showWarning && (
          <div className="rw-alert-banner" role="alert">
            <div className="rw-alert-icon" aria-hidden="true">
              <FeatherIcon icon="alert-triangle" size={18} />
            </div>
            <div className="rw-alert-body">
              <div className="rw-alert-text">
                <strong>유의사항</strong>
                <p>해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 있습니다. 작성된 리뷰로 인해 발생하는 모든 법적 분쟁의 책임은 작성자에게 귀속됩니다.</p>
              </div>
              <div className="rw-alert-actions">
                <label className="rw-alert-agree" htmlFor="rmw-warning-agree">
                  <input
                    id="rmw-warning-agree"
                    type="checkbox"
                    checked={this.warningAgreed}
                    onChange={() => this.toggleWarningAgree()}
                  />
                  <span className="rw-alert-agree-box" aria-hidden="true">
                    {this.warningAgreed && <FeatherIcon icon="check" size={11} />}
                  </span>
                  <span className="rw-alert-agree-label">위 유의사항에 동의합니다</span>
                </label>
                <button
                  type="button"
                  className="rw-alert-confirm-btn"
                  disabled={!this.warningAgreed}
                  onClick={() => this.dismissWarning()}
                  aria-label={this.warningAgreed ? '동의하고 닫기' : '동의 후 닫기 가능'}
                >
                  <FeatherIcon icon="check" size={13} />
                  동의하고 닫기
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 스텝 인디케이터 */}
        <nav className="rmw-stepper" aria-label="등록 진행 단계">
          {stepDefs.map((s, i) => {
            const isCurrent = this.currentStep === s.n;
            const isCompleted = this.maxReachedStep > s.n || (s.n === 3 && !!this.registerResult);
            return (
              <React.Fragment key={s.n}>
                <button
                  type="button"
                  className={`rmw-stepper__item${isCurrent ? ' is-current' : ''}${isCompleted ? ' is-completed' : ''}`}
                  onClick={() => this.setStep(s.n)}
                  aria-current={isCurrent ? 'step' : undefined}
                >
                  <span className="rmw-stepper__circle">
                    {isCompleted ? <FeatherIcon icon="check" size={16} /> : <span>{s.n}</span>}
                  </span>
                  <span className="rmw-stepper__label">{s.label}</span>
                </button>
                {i < stepDefs.length - 1 && (
                  <span className={`rmw-stepper__line${isCompleted ? ' is-completed' : ''}`} aria-hidden="true" />
                )}
              </React.Fragment>
            );
          })}
        </nav>

        <div className="rmw-content">
          {/* STEP 1 — 파일 업로드 & 가이드 (통합 2단 레이아웃) */}
          <section id="rmw-step-1" className={`rmw-section${this.showWarning ? ' is-locked' : ''}`}>
            {this.showWarning && (
              <div className="rmw-lock-overlay" aria-hidden="true">
                <div className="rmw-lock-overlay__message">
                  <FeatherIcon icon="lock" size={24} />
                  <span>유의사항에 동의한 후 사용할 수 있습니다</span>
                </div>
              </div>
            )}
            <header className="rmw-section__header">
              <span className="rmw-section__step">STEP 1</span>
              <h2 className="rmw-section__title">파일 업로드 & 가이드</h2>
              <p className="rmw-section__desc">
                엑셀 파일을 업로드하세요.<br/>
                오른쪽 가이드에서 자주 틀리는 항목을 확인할 수 있습니다.
              </p>
            </header>

            <div className="rmw-upload-guide rmw-upload-guide--stack">
              {/* === 상단: 업로드 === */}
              <div className="rmw-upload-guide__left">
                {/* 플랫폼 선택 */}
                <div className="rmw-segment" role="radiogroup" aria-label="플랫폼 선택">
                  {[
                    { value: 'my', label: '온리플', icon: 'package' },
                    { value: 'smartstore', label: '스마트스토어', icon: 'shopping-bag' },
                    { value: 'custom', label: '내 양식', icon: 'sliders' },
                  ].map(opt => (
                    <button
                      key={opt.value}
                      type="button"
                      role="radio"
                      aria-checked={this.filePlatform === opt.value}
                      className={`rmw-segment__item${this.filePlatform === opt.value ? ' is-active' : ''}`}
                      onClick={() => this.setFilePlatform(opt.value)}
                    >
                      <FeatherIcon icon={opt.icon} size={18} />
                      <span>{opt.label}</span>
                    </button>
                  ))}
                </div>

                {this.filePlatform === 'custom' && (
                  <div className="rmw-custom-hint">
                    <FeatherIcon icon="info" size={14} />
                    <span>사용자 정의 양식 모드입니다. 파일 업로드 후 컬럼을 시스템 필드와 매칭하면 됩니다.</span>
                    {this.savedMappings.length > 0 && (
                      <span className="rmw-custom-hint__count">저장된 양식 {this.savedMappings.length}개</span>
                    )}
                    {this.parsedHeaders.length > 0 && (
                      <button type="button" className="rmw-btn rmw-btn--ghost rmw-btn--sm" onClick={() => this.openMappingModal(this.parsedHeaders)}>
                        <FeatherIcon icon="edit-3" size={12} />
                        매칭 다시 설정
                      </button>
                    )}
                  </div>
                )}

                {this.currentMapping && this.filePlatform === 'custom' && (
                  <div className="rmw-current-mapping">
                    <FeatherIcon icon="check-circle" size={14} />
                    <span>적용된 양식: <strong>{this.currentMapping.name}</strong></span>
                  </div>
                )}

                {/* 드롭존 */}
                <div
                  className={`rmw-dropzone rmw-dropzone--tall${this.isExcelDragOver ? ' is-dragover' : ''}${this.selectedFile ? ' has-file' : ''}`}
                  onDragEnter={this.handleExcelDragEnter}
                  onDragOver={this.handleExcelDragOverEvent}
                  onDragLeave={this.handleExcelDragLeave}
                  onDrop={this.handleExcelDrop}
                  onClick={() => { if (!this.selectedFile) this.triggerExcelFileInput(); }}
                  onKeyDown={(e) => {
                    if ((e.key === 'Enter' || e.key === ' ') && !this.selectedFile) {
                      e.preventDefault();
                      this.triggerExcelFileInput();
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label="엑셀 또는 CSV 파일 업로드 영역"
                >
                  {!this.selectedFile ? (
                    <div className="rmw-dropzone__inner">
                      <div className="rmw-dropzone__icon">
                        <FeatherIcon icon="upload-cloud" size={48} />
                      </div>
                      <p className="rmw-dropzone__title">엑셀 또는 CSV 파일을 드래그하거나 클릭하여 업로드</p>
                      <p className="rmw-dropzone__hint">지원 형식: .xlsx, .csv · 최대 500건</p>
                    </div>
                  ) : (
                    <div className="rmw-file-info">
                      <div className="rmw-file-info__icon">
                        <FeatherIcon icon="file-text" size={28} />
                      </div>
                      <div className="rmw-file-info__body">
                        <div className="rmw-file-info__name">{this.selectedFile.name}</div>
                        <div className="rmw-file-info__meta">
                          {this.formatFileSize(this.selectedFile.size)}
                          {totalCount > 0 && <> · {totalCount}건의 리뷰 감지됨</>}
                        </div>
                      </div>
                      <button
                        type="button"
                        className="rmw-file-info__remove"
                        onClick={(e) => { e.stopPropagation(); this.removeExcelFile(); }}
                        aria-label="파일 제거"
                      >
                        <FeatherIcon icon="x" size={16} />
                      </button>
                    </div>
                  )}
                </div>
                <input
                  id="rmw-excel-input"
                  type="file"
                  accept=".csv, .xlsx, .xls"
                  onChange={this.handleExcelFileChange}
                  style={{ display: 'none' }}
                />

                {this.selectedFile && totalCount > 0 && (
                  <div className="rmw-validation" role="status" aria-live="polite">
                    {validCount > 0 && (
                      <div className="rmw-validation__item rmw-validation__item--success">
                        <FeatherIcon icon="check-circle" size={16} />
                        <span>유효한 리뷰 {validCount}건</span>
                      </div>
                    )}
                    {invalidCount > 0 && (
                      <div className="rmw-validation__item rmw-validation__item--warning">
                        <FeatherIcon icon="alert-triangle" size={16} />
                        <span>경고: {invalidCount}건의 필수 항목 누락</span>
                      </div>
                    )}
                    {syntaxRiskCount > 0 && (
                      <div className="rmw-validation__item rmw-validation__item--danger">
                        <FeatherIcon icon="x-circle" size={16} />
                        <span>오류: 문법 오류 위험 {syntaxRiskCount}건</span>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* === 하단: 다운로드 + 자주 틀리는 3가지 가이드 (1col 풀폭) === */}
              <div className="rmw-upload-guide__right rmw-upload-guide__right--full">
                {/* 양식 다운로드 */}
                <div className="rmw-download-bar">
                  <a
                    className="rmw-download-bar__link"
                    href="https://orpfrt.onreview.co.kr/downloads/onreple_review_guide.xlsx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FeatherIcon icon="file-text" size={14} />
                    샘플 가이드
                    <FeatherIcon icon="download" size={12} />
                  </a>
                  <a
                    className="rmw-download-bar__link rmw-download-bar__link--primary"
                    href="https://orpfrt.onreview.co.kr/downloads/onreple_review.xlsx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FeatherIcon icon="file-plus" size={14} />
                    엑셀 양식 다운로드
                    <FeatherIcon icon="download" size={12} />
                  </a>
                </div>

                {/* ① 상품번호 안내 카드 */}
                <div className="rmw-guide-card rmw-guide-card--warning">
                  <div className="rmw-guide-card__header">
                    <FeatherIcon icon="link" size={16} />
                    <h4 className="rmw-guide-card__title">상품번호 어디서 확인하나요?</h4>
                  </div>
                  <p className="rmw-guide-card__desc">
                    리뷰/답글 &gt; 리뷰작성 페이지의<br/>
                    '상품번호' 컬럼에서 확인하세요.
                  </p>
                  <a className="rmw-guide-card__cta" href="/reviewWrite" target="_blank" rel="noreferrer">
                    리뷰작성 페이지 바로가기 <FeatherIcon icon="arrow-right" size={13} />
                  </a>
                </div>

                {/* ② 별점 점수 매핑 카드 */}
                <div className="rmw-guide-card rmw-guide-card--primary">
                  <div className="rmw-guide-card__header">
                    <FeatherIcon icon="star" size={16} />
                    <h4 className="rmw-guide-card__title">별점은 점수로 입력하세요</h4>
                  </div>
                  <p className="rmw-guide-card__desc">
                    리뷰의 별점은 숫자로 입력해주세요.<br/>
                    1점=20, 2점=40 ... 5점=100입니다.
                  </p>
                  <div className="rmw-guide-card__rating-map">
                    <span>★=20</span><span>★★=40</span><span>★★★=60</span><span>★★★★=80</span><span>★★★★★=100</span>
                  </div>
                </div>

                {/* ③ 필수 항목 체크리스트 카드 */}
                <div className="rmw-guide-card rmw-guide-card--success">
                  <div className="rmw-guide-card__header">
                    <FeatherIcon icon="check-circle" size={16} />
                    <h4 className="rmw-guide-card__title">필수 항목 6개를 모두 채웠나요?</h4>
                  </div>
                  <ul className="rmw-guide-card__checklist">
                    <li>☑ <code>contents</code> — 리뷰 내용</li>
                    <li>☑ <code>goodsPt</code> — 별점 점수</li>
                    <li>☑ <code>platformProductId</code> — 상품 번호</li>
                    <li>☑ <code>writerAt</code> — 리뷰 작성일</li>
                    <li>☑ <code>writerId</code> — 작성자 ID</li>
                    <li>☑ <code>writerName</code> — 작성자 이름</li>
                  </ul>
                  <button
                    type="button"
                    className="rmw-guide-card__toggle"
                    onClick={() => { this.fieldDetailExpanded = !this.fieldDetailExpanded; }}
                    aria-expanded={this.fieldDetailExpanded}
                  >
                    {this.fieldDetailExpanded ? '접기' : '전체 필드 상세 보기'}
                    <FeatherIcon icon={this.fieldDetailExpanded ? 'chevron-up' : 'chevron-down'} size={14} />
                  </button>
                  {this.fieldDetailExpanded && (
                    <div className="rmw-guide-card__detail" style={{animation: 'rmw-fade-in 0.2s ease'}}>
                      <table className="rmw-required-table">호
                        <thead>
                          <tr><th scope="col">필드명</th><th scope="col">설명</th><th scope="col">예시</th></tr>
                        </thead>
                        <tbody>
                          <tr><td><code>contents</code></td><td>리뷰 내용</td><td>"상품이 좋아요"</td></tr>
                          <tr><td><code>goodsPt</code></td><td>별점 점수</td><td>100 (5점)</td></tr>
                          <tr><td><code>platformProductId</code></td><td>상품 번호</td><td>3593</td></tr>
                          <tr><td><code>writerAt</code></td><td>리뷰 작성일</td><td>2025-01-01</td></tr>
                          <tr><td><code>writerId</code></td><td>작성자 ID</td><td>user123</td></tr>
                          <tr><td><code>writerName</code></td><td>작성자 이름</td><td>홍길동</td></tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* 주의사항 아코디언 */}
                <div className="rmw-card rmw-accordion">
                  <button
                    type="button"
                    className="rmw-accordion__header"
                    onClick={() => this.toggleNoticeAccordion()}
                    aria-expanded={this.noticeAccordionOpen}
                  >
                    <span className="rmw-accordion__title">
                      <FeatherIcon icon="info" size={16} />
                      기타 주의사항 (펼쳐서 확인)
                    </span>
                    <FeatherIcon icon={this.noticeAccordionOpen ? 'chevron-up' : 'chevron-down'} size={16} />
                  </button>
                  {this.noticeAccordionOpen && (
                    <div className="rmw-accordion__body">
                      <div className="rmw-notice-item">
                        <FeatherIcon icon="alert-triangle" size={16} className="rmw-notice-item__icon rmw-notice-item__icon--warning" />
                        <p>이미지 주소를 입력하실 때, 해당 이미지가 인터넷에서 계속 유지되어야 정상적으로 보입니다.</p>
                      </div>
                      <div className="rmw-notice-item">
                        <FeatherIcon icon="info" size={16} className="rmw-notice-item__icon rmw-notice-item__icon--info" />
                        <p>대량 등록된 리뷰는 카페24 리뷰게시판에는 등록되지 않습니다. 카페24 리뷰게시판에도 등록을 원할 시 <Link to="/reviewWrite">리뷰/답글 &gt; 리뷰작성</Link> 페이지에서 개별 작성해 주세요.</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>

          {/* STEP 2 — 데이터 확인 & 편집 */}
          <section id="rmw-step-2" className="rmw-section">

            <header className="rmw-section__header">
              <span className="rmw-section__step">STEP 2</span>
              <h2 className="rmw-section__title">데이터 확인 & 편집</h2>
              <p className="rmw-section__desc">업로드된 리뷰 데이터를 확인하고 필요한 경우 수정하세요.</p>
            </header>

            {totalCount === 0 ? (
              <div className="rmw-empty">
                <div className="rmw-empty__icon">
                  <FeatherIcon icon="inbox" size={56} />
                </div>
                <p className="rmw-empty__title">엑셀 파일을 업로드하면 리뷰 데이터가 여기에 표시됩니다</p>
              </div>
            ) : (
              <div className="rmw-data-card">
                {selectedCount > 0 && (
                  <div className="rmw-bulk-bar">
                    <div className="rmw-bulk-bar__info">
                      <FeatherIcon icon="check-square" size={16} />
                      <strong>{selectedCount}</strong>건 선택됨
                    </div>
                    <div className="rmw-bulk-bar__actions">
                      <button type="button" className="rmw-btn rmw-btn--ghost rmw-btn--sm" onClick={() => this.toggleSelectAll()}>
                        {isAllSelected ? '선택 해제' : '전체 선택'}
                      </button>
                      <button type="button" className="rmw-btn rmw-btn--danger rmw-btn--sm" onClick={() => this.removeSelectedRows()}>
                        <FeatherIcon icon="trash-2" size={14} />
                        선택 항목 삭제
                      </button>
                    </div>
                  </div>
                )}

                <div className="rmw-table-wrap">
                  <table className="rmw-data-table" aria-label="업로드된 리뷰 데이터">
                    <colgroup>
                      <col style={{ width: '40px' }} />
                      <col style={{ width: '50px' }} />
                      <col style={{ width: '18%' }} />
                      <col style={{ width: '24%' }} />
                      <col style={{ width: '10%' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '12%' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '52px' }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">
                          <input
                            type="checkbox"
                            aria-label="전체 선택"
                            checked={isAllSelected}
                            onChange={() => this.toggleSelectAll()}
                          />
                        </th>
                        <th scope="col">#</th>
                        <th scope="col">상품</th>
                        <th scope="col">내용</th>
                        <th scope="col">작성자</th>
                        <th scope="col">평점</th>
                        <th scope="col">배송별점</th>
                        <th scope="col">작성일</th>
                        <th scope="col">첨부</th>
                        <th scope="col">상태</th>
                        <th scope="col" aria-label="액션"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.list.map((item, i) => {
                        const status = this.getRowStatus(item);
                        const isProblem = status === 'error' || status === 'warning';
                        if (this.showProblemsOnly && !isProblem) return null;
                        const isSelected = !!this.selectedRows[i];
                        const productInfo = this.goodList[item.platformProductId];
                        const imageCount = item.images ? item.images.length : 0;
                        const movieCount = item.movies ? item.movies.length : 0;
                        const hasAttachment = imageCount > 0 || movieCount > 0;
                        return (
                          <tr key={i} data-row-index={i} className={`rmw-data-row rmw-data-row--${status}${isSelected ? ' is-selected' : ''}`}>
                            <td className="rmw-data-row__cell rmw-data-row__cell--checkbox">
                              <input
                                type="checkbox"
                                aria-label={`${i + 1}번 행 선택`}
                                checked={isSelected}
                                onChange={() => this.toggleSelectRow(i)}
                              />
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--num">{i + 1}</td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--product">
                              {productInfo ? (
                                <div className="rmw-product">
                                  <img className="rmw-product__thumb" src={productInfo.images.s_2} alt="" />
                                  <div className="rmw-product__name" title={productInfo.productName}>{productInfo.productName}</div>
                                </div>
                              ) : (
                                <div className="rmw-product rmw-product--missing">
                                  <div className="rmw-product__name">{item.platformProductId} - 상품정보 없음</div>
                                  <button
                                    type="button"
                                    className="rmw-product__search-trigger"
                                    onClick={() => this.openProductSearchModal(i)}
                                    aria-label="상품 검색하여 선택"
                                  >
                                    <FeatherIcon icon="search" size={12} />
                                    <span>상품 검색 · 선택</span>
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className={`rmw-data-row__cell rmw-data-row__cell--contents${this.isSyntaxRiskReview(item) ? ' has-syntax-risk' : ''}`}>
                              {this.isSyntaxRiskReview(item) && (
                                <div className="rmw-cell-warning">
                                  <FeatherIcon icon="alert-triangle" size={12} />
                                  <span>{this.getSyntaxRiskField(item)} 필드 위험</span>
                                </div>
                              )}
                              {this.isEditing(i, 'contents') ? (
                                <div className="rmw-cell-edit">
                                  <FormTextarea defaultValue={item.contents || ''} rows={3} id={`contents-${i}`} />
                                  <div className="rmw-cell-edit__actions">
                                    <Button size="sm" theme="success" onClick={() => this.updateReviewField(i, 'contents', document.getElementById(`contents-${i}`).value)}>저장</Button>
                                    <Button size="sm" theme="secondary" onClick={() => this.cancelEdit(i, 'contents')}>취소</Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="rmw-cell-view">
                                  <div className="rmw-cell-view__text rmw-cell-view__text--multi">{item.contents || '내용 없음'}</div>
                                  <button type="button" className="rmw-cell-edit-btn" onClick={() => this.toggleEditMode(i, 'contents')} aria-label="내용 수정">
                                    <FeatherIcon icon="edit-2" size={12} />
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--writer">
                              {this.isEditing(i, 'writerName') ? (
                                <div className="rmw-cell-edit">
                                  <FormInput type="text" defaultValue={item.writerName || ''} size="sm" id={`writerName-${i}`} />
                                  <div className="rmw-cell-edit__actions">
                                    <Button size="sm" theme="success" onClick={() => this.updateReviewField(i, 'writerName', document.getElementById(`writerName-${i}`).value)}>저장</Button>
                                    <Button size="sm" theme="secondary" onClick={() => this.cancelEdit(i, 'writerName')}>취소</Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="rmw-cell-view">
                                  <span className="rmw-cell-view__text">{item.writerName || '없음'}</span>
                                  <button type="button" className="rmw-cell-edit-btn" onClick={() => this.toggleEditMode(i, 'writerName')} aria-label="작성자 수정">
                                    <FeatherIcon icon="edit-2" size={12} />
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--rating">
                              {this.isEditing(i, 'goodsPt') ? (
                                <div className="rmw-cell-edit">
                                  <FormSelect defaultValue={item.goodsPt || ''} size="sm" id={`goodsPt-${i}`}>
                                    <option value="">평점</option>
                                    <option value="20">★ 20</option>
                                    <option value="40">★★ 40</option>
                                    <option value="60">★★★ 60</option>
                                    <option value="80">★★★★ 80</option>
                                    <option value="100">★★★★★ 100</option>
                                  </FormSelect>
                                  <div className="rmw-cell-edit__actions">
                                    <Button size="sm" theme="success" onClick={() => this.updateReviewField(i, 'goodsPt', document.getElementById(`goodsPt-${i}`).value)}>저장</Button>
                                    <Button size="sm" theme="secondary" onClick={() => this.cancelEdit(i, 'goodsPt')}>취소</Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="rmw-cell-view">
                                  <span className="rmw-stars">{item.goodsPt ? this.getStarRating(item.goodsPt) : '☆☆☆☆☆'}</span>
                                  <button type="button" className="rmw-cell-edit-btn" onClick={() => this.toggleEditMode(i, 'goodsPt')} aria-label="평점 수정">
                                    <FeatherIcon icon="edit-2" size={12} />
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--rating">
                              {this.isEditing(i, 'deliveryPt') ? (
                                <div className="rmw-cell-edit">
                                  <FormSelect defaultValue={item.deliveryPt || ''} size="sm" id={`deliveryPt-${i}`}>
                                    <option value="">배송별점</option>
                                    <option value="20">★ 20</option>
                                    <option value="40">★★ 40</option>
                                    <option value="60">★★★ 60</option>
                                    <option value="80">★★★★ 80</option>
                                    <option value="100">★★★★★ 100</option>
                                  </FormSelect>
                                  <div className="rmw-cell-edit__actions">
                                    <Button size="sm" theme="success" onClick={() => this.updateReviewField(i, 'deliveryPt', document.getElementById(`deliveryPt-${i}`).value)}>저장</Button>
                                    <Button size="sm" theme="secondary" onClick={() => this.cancelEdit(i, 'deliveryPt')}>취소</Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="rmw-cell-view">
                                  <span className="rmw-stars">{this.getStarRating(item.deliveryPt || 100)}</span>
                                  <button type="button" className="rmw-cell-edit-btn" onClick={() => this.toggleEditMode(i, 'deliveryPt')} aria-label="배송별점 수정">
                                    <FeatherIcon icon="edit-2" size={12} />
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--date">
                              {this.isEditing(i, 'writerAt') ? (
                                <div className="rmw-cell-edit">
                                  <FormInput
                                    type="datetime-local"
                                    defaultValue={item.writerAt ? moment(item.writerAt).format("YYYY-MM-DDTHH:mm") : ''}
                                    size="sm"
                                    id={`writerAt-${i}`}
                                  />
                                  <div className="rmw-cell-edit__actions">
                                    <Button size="sm" theme="success" onClick={() => this.updateReviewField(i, 'writerAt', document.getElementById(`writerAt-${i}`).value)}>저장</Button>
                                    <Button size="sm" theme="secondary" onClick={() => this.cancelEdit(i, 'writerAt')}>취소</Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="rmw-cell-view">
                                  <span className="rmw-cell-view__text">{item.writerAt ? moment(item.writerAt).format("YYYY-MM-DD HH:mm") : '날짜 없음'}</span>
                                  <button type="button" className="rmw-cell-edit-btn" onClick={() => this.toggleEditMode(i, 'writerAt')} aria-label="작성일 수정">
                                    <FeatherIcon icon="edit-2" size={12} />
                                  </button>
                                </div>
                              )}
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--attach">
                              {hasAttachment ? (
                                <div className="rmw-attach">
                                  {movieCount > 0 && (
                                    <span className="rmw-attach__badge"><FeatherIcon icon="video" size={12} />{movieCount}</span>
                                  )}
                                  {imageCount > 0 && (
                                    <span className="rmw-attach__badge"><FeatherIcon icon="image" size={12} />{imageCount}</span>
                                  )}
                                </div>
                              ) : (
                                <span className="rmw-attach__none">-</span>
                              )}
                              <details className="rmw-attach-details">
                                <summary>관리</summary>
                                <div className="rmw-attach-details__body">
                                  {item.movies && item.movies[0] && (
                                    <video controls width="120">
                                      <source src={item.movies[0].url} type="video/webm" />
                                    </video>
                                  )}
                                  {item.thumbs && item.thumbs.length > 0 && item.thumbs.map((thumb, index) => {
                                    const imageObj = item.images && item.images[index] ? item.images[index] : thumb;
                                    return (
                                      <div key={index} className="rmw-attach-row">
                                        <img
                                          className="rmw-attach-row__thumb"
                                          src={thumb.url}
                                          alt=""
                                          onClick={() => window.open(imageObj.url, '_blank')}
                                        />
                                        <button type="button" className="rmw-attach-row__remove" onClick={() => this.removeImage(i, index)} aria-label="이미지 삭제">
                                          <FeatherIcon icon="x" size={12} />
                                        </button>
                                      </div>
                                    );
                                  })}
                                  <div
                                    className={`drag-upload-area${this.dragUploadIndex === i ? ' drag-upload-area--over' : ''}`}
                                    onClick={() => this.handleDropAreaClick(i)}
                                    onDragEnter={(event) => this.handleDragOverUpload(event, i)}
                                    onDragOver={(event) => this.handleDragOverUpload(event, i)}
                                    onDragLeave={(event) => this.handleDragLeaveUpload(event, i)}
                                    onDrop={(event) => this.handleDropUpload(event, i)}
                                  >
                                    <FeatherIcon icon="upload" size={16} />
                                    <p className="mb-1">이미지 추가</p>
                                  </div>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={(event) => this.handleImageUpload(event, i)}
                                    style={{ display: "none" }}
                                    id={`imageUpload-${i}`}
                                    disabled={this.isUploading}
                                  />
                                </div>
                              </details>
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--status">
                              {status === 'valid' && <span className="rmw-badge rmw-badge--success">유효</span>}
                              {status === 'warning' && <span className="rmw-badge rmw-badge--warning">경고</span>}
                              {status === 'error' && <span className="rmw-badge rmw-badge--danger">오류</span>}
                            </td>
                            <td className="rmw-data-row__cell rmw-data-row__cell--action">
                              <button type="button" className="rmw-icon-btn rmw-icon-btn--danger" onClick={() => this.removeReview(i)} aria-label="리뷰 삭제">
                                <FeatherIcon icon="trash-2" size={14} />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {(invalidCount > 0 || syntaxRiskCount > 0) && (
                  <div className="rmw-problem-banner" role="alert">
                    <div className="rmw-problem-banner__icon">
                      <FeatherIcon icon="alert-triangle" size={18} />
                    </div>
                    <div className="rmw-problem-banner__body">
                      <div className="rmw-problem-banner__title">
                        문제가 있는 리뷰 <strong>{invalidCount + syntaxRiskCount}건</strong>이 있습니다
                      </div>
                      <div className="rmw-problem-banner__desc">
                        {invalidCount > 0 && <>필수 항목 누락 <strong>{invalidCount}건</strong></>}
                        {invalidCount > 0 && syntaxRiskCount > 0 && <> · </>}
                        {syntaxRiskCount > 0 && <>문법 오류 위험 <strong>{syntaxRiskCount}건</strong></>}
                        {' '}— 수정 또는 삭제 후 등록할 수 있습니다.
                      </div>
                    </div>
                    <div className="rmw-problem-banner__actions">
                      <button
                        type="button"
                        className="rmw-btn rmw-btn--ghost rmw-btn--sm"
                        onClick={() => this.scrollToFirstProblem()}
                      >
                        <FeatherIcon icon="arrow-down-circle" size={14} />
                        문제 리뷰로 이동
                      </button>
                      <button
                        type="button"
                        className={`rmw-btn rmw-btn--sm ${this.showProblemsOnly ? 'rmw-btn--primary' : 'rmw-btn--ghost'}`}
                        onClick={() => this.toggleShowProblemsOnly()}
                        aria-pressed={this.showProblemsOnly}
                      >
                        <FeatherIcon icon={this.showProblemsOnly ? 'eye-off' : 'filter'} size={14} />
                        {this.showProblemsOnly ? '전체 보기' : '문제 리뷰만 보기'}
                      </button>
                      <button
                        type="button"
                        className="rmw-btn rmw-btn--danger rmw-btn--sm"
                        onClick={() => this.removeProblemReviews()}
                      >
                        <FeatherIcon icon="trash-2" size={14} />
                        문제 리뷰 일괄 삭제 ({invalidCount + syntaxRiskCount})
                      </button>
                    </div>
                  </div>
                )}

                <div className="rmw-submit-bar">
                  <div className="rmw-submit-bar__info">
                    {validCount > 0 ? (
                      <span><strong>{validCount}건</strong>의 리뷰가 등록 준비되었습니다</span>
                    ) : (
                      <span className="rmw-text-danger">등록 가능한 리뷰가 없습니다</span>
                    )}
                    {(invalidCount > 0 || syntaxRiskCount > 0) && (
                      <span className="rmw-submit-bar__warn">
                        <FeatherIcon icon="alert-triangle" size={14} />
                        문제 리뷰 {invalidCount + syntaxRiskCount}건을 먼저 수정하거나 삭제해주세요
                      </span>
                    )}
                  </div>
                  <div className="rmw-submit-bar__actions">
                    <button
                      type="button"
                      className="rmw-btn rmw-btn--primary rmw-btn--lg"
                      onClick={() => this.updateMassReview()}
                      disabled={!(this.list && this.list.length > 0) || invalidCount > 0 || syntaxRiskCount > 0 || this.isSubmitting || !this.warningAgreed}
                      title={!this.warningAgreed ? '유의사항에 먼저 동의해 주세요' : ''}
                    >
                      {this.isSubmitting ? (
                        <>
                          <span className="rmw-spinner" aria-hidden="true" />
                          등록 중...
                        </>
                      ) : (
                        <>
                          <FeatherIcon icon="upload" size={16} />
                          {validCount > 0 ? `${validCount}건의 리뷰 등록하기` : '리뷰 등록하기'}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Step 4 - 등록 완료 결과 */}
          {this.registerResult && (
            <section id="rmw-step-4" className="rmw-section rmw-section--success">
              <div className="rmw-success-banner" role="status" aria-live="polite">
                <FeatherIcon icon="check-circle" size={24} />
                <span><strong>{this.registerResult.success}건</strong>의 리뷰가 성공적으로 등록되었습니다</span>
              </div>
              <div className="rmw-result-grid">
                <div className="rmw-result-card rmw-result-card--success">
                  <div className="rmw-result-card__label">등록 성공</div>
                  <div className="rmw-result-card__value">{this.registerResult.success}<small>건</small></div>
                </div>
                <div className="rmw-result-card rmw-result-card--danger">
                  <div className="rmw-result-card__label">등록 실패</div>
                  <div className="rmw-result-card__value">{this.registerResult.fail}<small>건</small></div>
                </div>
                <div className="rmw-result-card rmw-result-card--info">
                  <div className="rmw-result-card__label">이미지 처리</div>
                  <div className="rmw-result-card__value">{this.registerResult.imageCount}<small>건</small></div>
                </div>
              </div>
              <div className="rmw-success-actions">
                <Link to="/reviewMassList">
                  <button type="button" className="rmw-btn rmw-btn--primary">
                    <FeatherIcon icon="list" size={16} />
                    등록된 리뷰 보기
                  </button>
                </Link>
                <button type="button" className="rmw-btn rmw-btn--ghost" onClick={() => this.resetForm()}>
                  <FeatherIcon icon="plus" size={16} />
                  추가 등록하기
                </button>
              </div>
            </section>
          )}

          {/* 외부 이미지 가져오기 (관리자 전용) */}
          {isAdmin && (
            <section className="rmw-section">
              <header className="rmw-section__header">
                <span className="rmw-section__step">EXTRA</span>
                <h2 className="rmw-section__title">외부 이미지 가져오기</h2>
                <p className="rmw-section__desc">엑셀에 입력한 이미지 URL을 서버로 가져와 저장합니다.</p>
              </header>

              <div className="rmw-card">
                <div className="rmw-card__body">
                  <div className="rmw-ex-img-actions">
                    {this.uploadImgStatus.completed > 0 && this.uploadImgStatus.total > 0 && (
                      <div
                        className="rmw-progress"
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={this.uploadImgStatus.total}
                        aria-valuenow={this.uploadImgStatus.completed}
                      >
                        <div
                          className="rmw-progress__bar"
                          style={{ width: `${(this.uploadImgStatus.completed / this.uploadImgStatus.total) * 100}%` }}
                        />
                        <div className="rmw-progress__label">{this.uploadImgStatus.completed} / {this.uploadImgStatus.total} 처리 중...</div>
                      </div>
                    )}
                    <button
                      type="button"
                      className="rmw-btn rmw-btn--outline"
                      onClick={() => this.uploadReviewExImgs()}
                      disabled={!(Array.isArray(this.exImgList) && this.exImgList.length > 0)}
                    >
                      <FeatherIcon icon="download" size={14} />
                      이미지 가져오기
                    </button>
                  </div>

                  {(!Array.isArray(this.exImgList) || this.exImgList.length === 0) ? (
                    <div className="rmw-empty rmw-empty--small">
                      <FeatherIcon icon="image" size={36} />
                      <p>리뷰를 먼저 등록한 후 이미지를 가져올 수 있습니다</p>
                    </div>
                  ) : (
                    <div className="rmw-img-grid">
                      {this.exImgList.map((item, i) => (
                        <div key={i} className="rmw-img-card">
                          {item.thumbs && item.thumbs.length > 0 ? (
                            item.thumbs.map((thumb, index) => (
                              <div key={index} className="rmw-img-card__item">
                                <img src={thumb.url} alt="" onClick={() => window.open(thumb.url, '_blank')} />
                              </div>
                            ))
                          ) : (
                            item.images && item.images.map((image, index) => (
                              <div key={index} className="rmw-img-card__item">
                                <img src={image.url} alt="" onClick={() => window.open(image.url, '_blank')} />
                              </div>
                            ))
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}

        </div>

        {/* 사용자 정의 컬럼 매칭 모달 — 스프레드시트 스타일 */}
        {this.isMappingModalOpen && (() => {
          const REQUIRED_FIELDS = ['contents','goodsPt','platformProductId','writerAt','writerId','writerName'];
          const OPTIONAL_FIELDS = ['subject','deliveryPt','images_1','images_2','images_3','images_4','images_5','movies_1','movies_2'];
          const FIELD_LABELS = {
            contents:'리뷰 내용', goodsPt:'평점', platformProductId:'상품 번호',
            writerAt:'작성일', writerId:'작성자 ID', writerName:'작성자 이름',
            subject:'제목', deliveryPt:'배송 별점',
            images_1:'이미지 #1', images_2:'이미지 #2', images_3:'이미지 #3', images_4:'이미지 #4', images_5:'이미지 #5',
            movies_1:'동영상 #1', movies_2:'동영상 #2',
          };
          const colToField = this.getColumnFieldMap();
          const filledRequired = REQUIRED_FIELDS.filter(f => this.mappingForm.fields[f]);
          const filledOptional = OPTIONAL_FIELDS.filter(f => this.mappingForm.fields[f]);
          const missingRequired = REQUIRED_FIELDS.filter(f => !this.mappingForm.fields[f]);
          const progress = Math.round((filledRequired.length / REQUIRED_FIELDS.length) * 100);
          const isReady = missingRequired.length === 0;
          const dropdownSearch = (this.dropdownSearch || '').toLowerCase().trim();
          const filterField = (f) => !dropdownSearch || FIELD_LABELS[f].toLowerCase().includes(dropdownSearch) || f.toLowerCase().includes(dropdownSearch);

          return (
          <Modal open={this.isMappingModalOpen} toggle={() => {}} modalClassName="rmw-cmm-wrap" className="rmw-cmm-dialog">
            <div className="rmw-cmm">
              {/* HEADER */}
              <header className="rmw-cmm__header">
                <div className="rmw-cmm__header-text">
                  <h2 className="rmw-cmm__title">엑셀 컬럼 매칭</h2>
                  <p className="rmw-cmm__subtitle">각 컬럼 위의 드롭다운에서 역할을 지정해주세요</p>
                </div>
                <button type="button" className="rmw-cmm__close" onClick={() => this.closeMappingModal()} aria-label="닫기">
                  <FeatherIcon icon="x" size={20} />
                </button>
              </header>

              {/* PROGRESS */}
              <div className="rmw-cmm__progress">
                <div className="rmw-cmm__progress-bar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={progress}>
                  <div
                    className={`rmw-cmm__progress-fill${isReady ? ' is-complete' : ''}`}
                    style={{ width: `${progress}%` }}
                  />
                </div>
                <div className="rmw-cmm__progress-info">
                  <span className="rmw-cmm__progress-stats">
                    <FeatherIcon icon={isReady ? 'check-circle' : 'circle'} size={14} />
                    필수 <strong>{filledRequired.length}/{REQUIRED_FIELDS.length}</strong> 완료 · 선택 <strong>{filledOptional.length}/{OPTIONAL_FIELDS.length}</strong> 매칭됨
                  </span>
                  {missingRequired.length > 0 && (
                    <span className="rmw-cmm__progress-warn">
                      <FeatherIcon icon="alert-triangle" size={14} />
                      {missingRequired.map(f => FIELD_LABELS[f]).join(', ')} 미지정
                    </span>
                  )}
                </div>
              </div>

              {/* SAVED MAPPINGS (compact) */}
              {this.savedMappings.length > 0 && (
                <div className="rmw-cmm__saved">
                  <span className="rmw-cmm__saved-label">
                    <FeatherIcon icon="bookmark" size={12} />
                    저장된 양식
                  </span>
                  <div className="rmw-cmm__saved-list">
                    {this.savedMappings.map(m => {
                      const sigMatch = this.computeColumnSignature(this.parsedHeaders) === m.columnSignature;
                      return (
                        <div key={m._id || m.id} className={`rmw-cmm__saved-item${sigMatch ? ' is-compatible' : ''}`}>
                          <button type="button" className="rmw-cmm__saved-use" onClick={() => this.useSavedMapping(m)}>
                            {sigMatch && <FeatherIcon icon="zap" size={11} />}
                            {m.name}
                          </button>
                          <button type="button" className="rmw-cmm__saved-del" onClick={() => this.deleteSavedMapping(m._id || m.id)} aria-label="삭제">
                            <FeatherIcon icon="x" size={11} />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* SPREADSHEET */}
              <div className="rmw-cmm__sheet-wrap">
                <div className="rmw-cmm__sheet-scroll">
                  <table className="rmw-cmm__sheet">
                    <colgroup>
                      {this.parsedHeaders.map(h => (
                        <col key={h} style={{ minWidth: '140px', maxWidth: '200px', width: '160px' }} />
                      ))}
                    </colgroup>
                    {/* 매칭 지정 행 (sticky) */}
                    <thead>
                      <tr className="rmw-cmm__assign-row">
                        {this.parsedHeaders.map((h, idx) => {
                          const field = colToField[h];
                          const isReq = REQUIRED_FIELDS.includes(field);
                          const isOpt = OPTIONAL_FIELDS.includes(field);
                          const status = isReq ? 'required' : isOpt ? 'optional' : 'unset';
                          const isAuto = field && this.autoMatchedFields[field];
                          const isDragOver = this.dragOverColumn === h;
                          return (
                            <th
                              key={h}
                              className={`rmw-cmm__assign rmw-cmm__col rmw-cmm__col--${status}${isDragOver ? ' is-drag-over' : ''}`}
                              onDragOver={(e) => this.handleColumnDragOver(e, h)}
                              onDragLeave={(e) => this.handleColumnDragLeave(e, h)}
                              onDrop={(e) => this.handleColumnDrop(e, h)}
                              aria-label={`${this.getColumnLetter(idx)}열 ${h} 컬럼${field ? `, 현재 '${FIELD_LABELS[field]}'으로 매칭됨` : ', 미매칭'}`}
                            >
                              <div
                                className={`rmw-cmm-chip rmw-cmm-chip--${status}`}
                                onClick={(e) => this.toggleColumnDropdown(h, e)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.toggleColumnDropdown(h, e);
                                  }
                                }}
                                role="button"
                                tabIndex={0}
                                aria-haspopup="listbox"
                                aria-expanded={this.openDropdownColumn === h}
                              >
                                {field ? (
                                  <>
                                    <FeatherIcon icon="check" size={12} />
                                    <span className="rmw-cmm-chip__label">{FIELD_LABELS[field]}</span>
                                    <button
                                      type="button"
                                      className="rmw-cmm-chip__clear"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        this.assignFieldToColumn(h, null);
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                          e.stopPropagation();
                                        }
                                      }}
                                      aria-label={`${FIELD_LABELS[field]} 매칭 해제`}
                                      title="매칭 해제"
                                    >
                                      <FeatherIcon icon="x" size={11} />
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <span className="rmw-cmm-chip__label">지정</span>
                                    <FeatherIcon icon="chevron-down" size={12} />
                                  </>
                                )}
                                {isAuto && <span className="rmw-cmm-chip__auto" title="자동 매칭됨" aria-label="자동 매칭됨"><span role="img" aria-label="로봇">🤖</span> 자동</span>}
                              </div>
                              {this.openDropdownColumn === h && (
                                <div className={`rmw-cmm-dropdown rmw-cmm-dropdown--align-${this.dropdownAlign}`} role="listbox">
                                  <div className="rmw-cmm-dropdown__search">
                                    <FeatherIcon icon="search" size={12} />
                                    <input
                                      type="text"
                                      placeholder="필드 검색..."
                                      value={this.dropdownSearch}
                                      onChange={(e) => this.setDropdownSearch(e.target.value)}
                                      autoFocus
                                    />
                                  </div>
                                  <div className="rmw-cmm-dropdown__group">
                                    <div className="rmw-cmm-dropdown__group-label">필수</div>
                                    {REQUIRED_FIELDS.filter(filterField).map(f => {
                                      const usedCol = this.mappingForm.fields[f];
                                      const isUsed = usedCol && usedCol !== h;
                                      const isCurrent = usedCol === h;
                                      return (
                                        <button
                                          key={f}
                                          type="button"
                                          role="option"
                                          aria-selected={isCurrent}
                                          className={`rmw-cmm-dropdown__item${isCurrent ? ' is-current' : ''}${isUsed ? ' is-used' : ''}`}
                                          onClick={() => this.assignFieldToColumn(h, f)}
                                          title={isUsed ? `${usedCol}열에 매칭됨 (선택 시 이동)` : ''}
                                        >
                                          <span className="rmw-cmm-dropdown__item-label">
                                            {FIELD_LABELS[f]} <span className="rmw-cmm-dropdown__req">*</span>
                                          </span>
                                          {isCurrent && <FeatherIcon icon="check" size={12} />}
                                          {isUsed && <span className="rmw-cmm-dropdown__used">{usedCol}열</span>}
                                        </button>
                                      );
                                    })}
                                  </div>
                                  <div className="rmw-cmm-dropdown__group">
                                    <div className="rmw-cmm-dropdown__group-label">선택</div>
                                    {OPTIONAL_FIELDS.filter(filterField).map(f => {
                                      const usedCol = this.mappingForm.fields[f];
                                      const isUsed = usedCol && usedCol !== h;
                                      const isCurrent = usedCol === h;
                                      return (
                                        <button
                                          key={f}
                                          type="button"
                                          role="option"
                                          aria-selected={isCurrent}
                                          className={`rmw-cmm-dropdown__item${isCurrent ? ' is-current' : ''}${isUsed ? ' is-used' : ''}`}
                                          onClick={() => this.assignFieldToColumn(h, f)}
                                          title={isUsed ? `${usedCol}열에 매칭됨 (선택 시 이동)` : ''}
                                        >
                                          <span className="rmw-cmm-dropdown__item-label">{FIELD_LABELS[f]}</span>
                                          {isCurrent && <FeatherIcon icon="check" size={12} />}
                                          {isUsed && <span className="rmw-cmm-dropdown__used">{usedCol}열</span>}
                                        </button>
                                      );
                                    })}
                                  </div>
                                  <div className="rmw-cmm-dropdown__footer">
                                    <button
                                      type="button"
                                      className="rmw-cmm-dropdown__clear"
                                      onClick={() => this.assignFieldToColumn(h, null)}
                                    >
                                      <FeatherIcon icon="slash" size={11} />
                                      사용 안 함
                                    </button>
                                  </div>
                                </div>
                              )}
                            </th>
                          );
                        })}
                      </tr>
                      {/* 컬럼 헤더 행 */}
                      <tr className="rmw-cmm__header-row">
                        {this.parsedHeaders.map((h, idx) => {
                          const field = colToField[h];
                          const isReq = REQUIRED_FIELDS.includes(field);
                          const isOpt = OPTIONAL_FIELDS.includes(field);
                          const status = isReq ? 'required' : isOpt ? 'optional' : 'unset';
                          return (
                            <th key={h} className={`rmw-cmm__col-header rmw-cmm__col--${status}`} scope="col">
                              <span className="rmw-cmm__col-letter">{this.getColumnLetter(idx)}</span>
                              <span className="rmw-cmm__col-name" title={h}>{h}</span>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    {/* 데이터 행 */}
                    <tbody>
                      {this.parsedRows.slice(0, 3).map((row, ri) => (
                        <tr key={ri} className="rmw-cmm__data-row">
                          {this.parsedHeaders.map(h => {
                            const field = colToField[h];
                            const isReq = REQUIRED_FIELDS.includes(field);
                            const isOpt = OPTIONAL_FIELDS.includes(field);
                            const status = isReq ? 'required' : isOpt ? 'optional' : 'unset';
                            const raw = row[h];
                            const val = raw == null ? '' : String(raw);
                            // 데이터 검증
                            let invalid = false;
                            if (field === 'goodsPt' || field === 'deliveryPt') {
                              if (val && isNaN(parseFloat(val))) invalid = true;
                            } else if (field === 'writerAt') {
                              if (val && isNaN(Date.parse(val)) && !(typeof raw === 'number')) invalid = true;
                            }
                            return (
                              <td
                                key={h}
                                className={`rmw-cmm__cell rmw-cmm__col--${status}${invalid ? ' is-invalid' : ''}`}
                                title={val}
                              >
                                {val.length > 40 ? val.slice(0, 40) + '…' : val || <span className="rmw-cmm__cell-empty">—</span>}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* 하단 인라인 옵션 */}
              <div className="rmw-cmm__inline">
                <div className="rmw-cmm__inline-group">
                  <label className="rmw-cmm__inline-label">평점 단위</label>
                  <div className="rmw-cmm__seg" role="radiogroup" aria-label="평점 단위">
                    <button
                      type="button"
                      role="radio"
                      aria-checked={this.mappingForm.ratingScale === '5'}
                      className={`rmw-cmm__seg-item${this.mappingForm.ratingScale === '5' ? ' is-active' : ''}`}
                      onClick={() => this.updateMappingMeta('ratingScale', '5')}
                    >5점 만점</button>
                    <button
                      type="button"
                      role="radio"
                      aria-checked={this.mappingForm.ratingScale === '100'}
                      className={`rmw-cmm__seg-item${this.mappingForm.ratingScale === '100' ? ' is-active' : ''}`}
                      onClick={() => this.updateMappingMeta('ratingScale', '100')}
                    >100점 만점</button>
                  </div>
                </div>
                <div className="rmw-cmm__inline-group rmw-cmm__inline-group--save">
                  <label className="rmw-cmm__check">
                    <input
                      type="checkbox"
                      checked={this.mappingForm.saveAfterApply}
                      onChange={(e) => this.updateMappingMeta('saveAfterApply', e.target.checked)}
                    />
                    <span>양식 저장</span>
                  </label>
                  {this.mappingForm.saveAfterApply && (
                    <input
                      type="text"
                      className="rmw-cmm__input"
                      placeholder="양식 이름 (예: 카페24 양식)"
                      value={this.mappingForm.name}
                      onChange={(e) => this.updateMappingMeta('name', e.target.value)}
                    />
                  )}
                </div>
              </div>

              {/* STICKY FOOTER */}
              <footer className="rmw-cmm__footer">
                <div className="rmw-cmm__footer-summary">
                  {isReady ? (
                    <span className="rmw-cmm__footer-ready">
                      <FeatherIcon icon="check-circle" size={16} />
                      필수 {REQUIRED_FIELDS.length}/{REQUIRED_FIELDS.length} 완료
                    </span>
                  ) : (
                    <span className="rmw-cmm__footer-warn">
                      <FeatherIcon icon="alert-triangle" size={16} />
                      필수 {missingRequired.length}개 미지정
                    </span>
                  )}
                </div>
                <div className="rmw-cmm__footer-actions">
                  <button type="button" className="rmw-cmm__btn rmw-cmm__btn--ghost" onClick={() => this.closeMappingModal()}>취소</button>
                  <button
                    type="button"
                    className="rmw-cmm__btn rmw-cmm__btn--primary"
                    onClick={() => this.applyMappingFromForm()}
                    disabled={!isReady}
                    title={!isReady ? '필수 항목을 모두 지정해주세요' : ''}
                  >
                    <FeatherIcon icon="check" size={14} />
                    매칭 적용
                  </button>
                </div>
              </footer>
            </div>
          </Modal>
          );
        })()}

        {/* 상품 검색 모달 */}
        {this.productSearchModal.isOpen && (
          <Modal
            open={this.productSearchModal.isOpen}
            toggle={() => this.closeProductSearchModal()}
            modalClassName="rmw-psm-wrap"
            className="rmw-psm-dialog"
          >
            <div className="rmw-psm">
              <header className="rmw-psm__header">
                <div className="rmw-psm__header-text">
                  <h2 className="rmw-psm__title">상품 검색 · 선택</h2>
                  <p className="rmw-psm__subtitle">
                    상품명 또는 상품번호로 검색해 이 리뷰의 상품을 지정하세요.
                  </p>
                </div>
                <button
                  type="button"
                  className="rmw-psm__close"
                  onClick={() => this.closeProductSearchModal()}
                  aria-label="닫기"
                >
                  <FeatherIcon icon="x" size={20} />
                </button>
              </header>

              <div className="rmw-psm__search">
                <FeatherIcon icon="search" size={16} className="rmw-psm__search-icon" />
                <input
                  type="text"
                  className="rmw-psm__search-input"
                  placeholder="상품명 또는 상품번호 입력..."
                  value={this.productSearchModal.query}
                  onChange={(e) => this.updateProductSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      this.searchProducts(this.productSearchModal.query);
                    }
                  }}
                  autoFocus
                />
                {this.productSearchModal.query && (
                  <button
                    type="button"
                    className="rmw-psm__search-clear"
                    onClick={() => this.updateProductSearchQuery('')}
                    aria-label="검색어 지우기"
                  >
                    <FeatherIcon icon="x" size={14} />
                  </button>
                )}
              </div>

              {(() => {
                const mc = this.productSearchModal.matchCount;
                const others = Math.max(0, mc - 1);
                const oid = this.productSearchModal.oldProductId;
                if (others > 0) {
                  return (
                    <label className="rmw-psm__bulk">
                      <input
                        type="checkbox"
                        checked={this.productSearchModal.applyToAll}
                        onChange={() => this.toggleProductSearchApplyAll()}
                      />
                      <span className="rmw-psm__bulk-text">
                        같은 상품번호 <strong>"{oid || '(없음)'}"</strong>가 있는 다른 <strong>{others}건</strong>에도 함께 적용 <span className="rmw-psm__bulk-total">(총 {mc}건)</span>
                      </span>
                    </label>
                  );
                }
                return (
                  <div className="rmw-psm__bulk rmw-psm__bulk--info">
                    <FeatherIcon icon="info" size={14} />
                    <span className="rmw-psm__bulk-text">
                      같은 상품번호 <strong>"{oid || '(없음)'}"</strong>를 가진 다른 리뷰가 없어 이 리뷰에만 적용됩니다
                    </span>
                  </div>
                );
              })()}

              <div className="rmw-psm__results">
                {this.productSearchModal.isSearching && this.productSearchModal.results.length === 0 ? (
                  <div className="rmw-psm__state">
                    <span className="rmw-spinner" />
                    검색 중...
                  </div>
                ) : this.productSearchModal.results.length === 0 ? (
                  (this.productSearchModal.query || '').trim() === '' ? (
                    <div className="rmw-psm__state">
                      <FeatherIcon icon="search" size={40} />
                      <p>상품명 또는 상품번호로 검색해주세요</p>
                      <span className="rmw-psm__state-hint">위 검색창에 입력 후 Enter를 누르세요</span>
                    </div>
                  ) : (
                    <div className="rmw-psm__state">
                      <FeatherIcon icon="package" size={40} />
                      <p>검색 결과가 없습니다</p>
                      <span className="rmw-psm__state-hint">다른 검색어로 시도해보세요</span>
                    </div>
                  )
                ) : (
                  <ul className="rmw-psm__list" role="listbox">
                    {this.productSearchModal.results.map((p, pi) => {
                      const pid = String(p.platformProductId || '');
                      const img = p.images && (p.images.s_2 || p.images.s_1 || p.images.t_2);
                      return (
                        <li
                          key={pid + '_' + pi}
                          className="rmw-psm__item"
                          role="option"
                          aria-selected={false}
                          tabIndex={0}
                          onClick={() => this.selectProductFromSearch(p)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              this.selectProductFromSearch(p);
                            }
                          }}
                        >
                          {img ? (
                            <img src={img} alt="" className="rmw-psm__item-thumb" />
                          ) : (
                            <div className="rmw-psm__item-thumb rmw-psm__item-thumb--placeholder">
                              <FeatherIcon icon="package" size={20} />
                            </div>
                          )}
                          <div className="rmw-psm__item-info">
                            <div className="rmw-psm__item-name" title={p.productName}>
                              {p.productName || '상품명 없음'}
                            </div>
                            <div className="rmw-psm__item-id">ID: {pid || '-'}</div>
                          </div>
                          <span className="rmw-psm__item-action">
                            선택
                            <FeatherIcon icon="arrow-right" size={12} />
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>

              <footer className="rmw-psm__footer">
                <div className="rmw-psm__footer-info">
                  {this.productSearchModal.results.length > 0 && (
                    <span>총 <strong>{this.productSearchModal.results.length}</strong>개 검색됨</span>
                  )}
                </div>
                <button
                  type="button"
                  className="rmw-cmm__btn rmw-cmm__btn--ghost"
                  onClick={() => this.closeProductSearchModal()}
                >
                  닫기
                </button>
              </footer>
            </div>
          </Modal>
        )}

        <ModalLoading isLoading={this.isLoading} />
      </div>
    )
  }
}

export default ReviewMassWrite;
